import React, { useEffect, useState } from "react";
import Menubar from "../Menubar";
import { Modal,Container, Row, Col, Table,Button } from "react-bootstrap";
import { store } from "../../App"; import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai"; import { exportToExcel, datetime, formatNumberIndianWithDecimal, generatePdf, commonSelectProps } from "../utils/commonFunctions"; import KpiService from "../../Services/KpiService"; import AlertModal from "../Alert/AlertModal"; import useAlert from "../Alert/useAlert"; import { Field, FormikProvider, Form, useFormik } from "formik"; import MasterService from "../../Services/MasterService";
import { IoIosReturnLeft } from "react-icons/io";
import Select from 'react-select';
export default function IndicatorWiseProgressReport() {
  const { showAlert, alertData,showAlertMessage, closeAlert } = useAlert(); const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); const [data, setData] = useState([]); const[subTableData,setSubTableData]=useState([]);const [Deptlist, setDeptlist] = useState([]); const [distlist, setDistrictList] = useState(); const [searchText, setSearch] = useState("");
 const [SubTableEnb,setSubTableEnb]=useState(false);
 const [SubDistTableEnb,setSubDistTableEnb]=useState(false);
 const[subDistTableData,setsubDistTableData]=useState([]);
 const[maintablenb,setmaintablenb]=useState(true);
 const [searchdistSub,setSearchdistsub]=useState("");
 const [selecteddist,setselecteddist]=useState("");const [monthList,setMonthList] = useState([]);
const [selectedmandal,setselectedmandal]=useState("");

 const [searchSub,setSearchsub]=useState("");
const [yearList,setYearList] = useState([]);
const [DrillType,setDrillType] = useState();
const [Entry,setEntry] = useState();
const [Head_id,setHead] = useState();

const [TargetCountEnb,setTargetCountEnb] = useState(false);
const [PendingAchEnb,setPendingAchEnb] = useState(false);
const [TargetMandalEnb,setTargetMandalEnb] = useState(false);
const [AchMandalEnb,setAchMandalEnb] = useState(false);

const [mandaltargetenb,setmandaltargetenb] = useState(false);
const [AchievementNamesEnb,setAchievementNamesEnb] = useState(false);
const [AchievementNamesdata,setAchievementNamesdata] = useState(false);

const [TargetsData,setTargetsData] = useState([]);
const [TargetsmandalData,setTargetsmandalData] = useState([]);
const [AchmandalData,setAchmandalData] = useState([]);

const [TargetNames,setTargetNames] = useState([]);
const [PendingAChievementData,setPendingAChievementData] = useState([]);
const [PendingmandalData,setPendingmandalData] = useState([]);
const [Pendingmandalenb,setPendingmandalenb] = useState(false);
const [selectedpendingDistrictName,setSelectedpendingDistrictName] = useState("");

const [searchTargetsText, setsearchTargetsText] = useState("");
const [searchmandalTargetsText, setsearchmandalTargetsText] = useState("");
const [searchmandalAchText, setsearchmandalAchText] = useState("");

const [searchPendingAchText, setsearchPendingAchText] = useState("");
const [searchTargetNamesText, setsearchTargetNamesText] = useState("");
const [searchAchNamesText, setsearchAchNamesText] = useState("");
const [EnteredAchEnb,setEnteredAchEnb] = useState(false);

 let ulbdeptlist=JSON.parse(localStorage.getItem("ulbdeptlist") || "[]");  let assembleid=localStorage.getItem("assemblyid");
  let username = localStorage.getItem("username"); let deptId = localStorage.getItem("deptid"); let district = localStorage.getItem("districtid");
  let roleid = localStorage.getItem("catid");
let mandalid = localStorage.getItem(ulbdeptlist.includes(deptId)?"ulbid":"mandalid");
  const formik = useFormik({
    initialValues: { department_id:"", district_id:"",year:"", entry_level:"",tr_entry_level:"",constid:"",month:"",},
  });
const[selecteddept,setselecteddept] = useState();

const entryLevelOptions = [
 ...(roleid !== "112" ? [{ value: "0", label: "All" }] : []),

  ...(["115", "116"].includes(roleid)
    ? [{ value: "secretariatLevel", label: "Secretariat Level" }]
    : []),

  ...(["115", "116", "114"].includes(roleid)
    ? [{ value: "hodLevel", label: "HOD Level" }]
    : []),

  ...(["115", "116", "114", "119", "113"].includes(roleid)
    ? [{ value: "districtLevel", label: "District Level" }]
    : []),

  ...(["115", "116", "114", "119", "113", "117", "111", "112"].includes(roleid)
    ? [{ value: "mandalLevel", label: "Mandal Level" }]
    : []),
];

  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);
        let params = { userId: username }
       
       MasterService.getkpiMonths(params).then((finachievres) => { if (finachievres.data) { setMonthList(finachievres.data.SDESC); } });
          MasterService.getAllDepts(params).then((res) => { if (res.data) { let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); }); 
        
    setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]); } });
         MasterService.getfinyears().then((achievvalueres) => {
             if (achievvalueres.data) {
               let options = achievvalueres.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
               setYearList(achievvalueres.data);
             }
           });
           MasterService.getDistricts().then((res17) => {
                if (res17.data) {
                 
                  let options = res17.data?.map((item, i) => { return (<option key={i} value={item.id}> {item.value} </option>); });
                  setDistrictList(res17.data);
                }
              });

              if(["113","119","117","111","112"].includes(roleid)){setselecteddist(localStorage.getItem("districtname"))}
              if(["117","111","112"].includes(roleid)){setselectedmandal(localStorage.getItem(ulbdeptlist.includes(deptId)?"ulbname":"mandalname"))}

if(["111","113","114","115"].includes(roleid)){formik.setFieldValue("department_id",deptId);
   
}
if(["113","114","111","115"].includes(roleid)){formik.setFieldValue("department_id",deptId);
    formik.setFieldValue("district_id",district);
}
if(["119","117","112"].includes(roleid)){
    formik.setFieldValue("district_id",district);
}
}, []);

const capitalizedformat=(str)=>{
  let converted=str
  if(str){
  converted=str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  return converted;
  }
  return ;
}
const allPeriods = [
  { name: "April", order: 4 },
  { name: "May", order: 5 },
  { name: "June/Q1", order: 6 },
  { name: "July", order: 7 },
  { name: "Aug", order: 8 },
  { name: "Sept/Q2/HY1", order: 9 },
  { name: "Oct", order: 10 },
  { name: "Nov", order: 11 },
  { name: "Dec/Q3", order: 12 },
  { name: "Jan", order: 1 },
  { name: "Feb", order: 2 },
  { name: "Mar/Q4/HY2/Annual", order: 3 },
  { name: "Bi Ennial", order: 13 },
  { name: "5 year", order: 14 },
];
// let filteredPeriods=allPeriods;
const filteredPeriods = formik.values.month? allPeriods.filter(p => 
  p.order === formik.values.month
):allPeriods;
const monthdata=(val)=>{


}
// const currentMonth = new Date().getMonth() + 1;

  const getData = (entry) => {
    if (!entry || !formik.values.department_id || !formik.values.year|| !formik.values.month) {
      setSubTableData([]);
      setData([]);
      setSubTableEnb(false);
      return;
    }
    // setselectedperiodic(parseInt(formik.values.periodic_id));
   
    let params={};
    if(["111","117"].includes(roleid)){
       params = {
    
        year: formik.values.year,
    userId: username,
    deptId:formik.values.department_id,
    buttonType: "sub",
    districtId:district.toString(),
    entryLevel: entry,
    mandalId:mandalid,
    monthOrder:formik.values.month


  };
}else{
    
    params = { 

      "userId": username,
    "buttonType": "main",
    "deptId": formik.values.department_id,
    "year":formik.values.year,
    "entryLevel":entry,
    districtId:district,
    ...(roleid === "112" ? {constId:assembleid}:{}),
    monthOrder:formik.values.month

};
} 
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.indicatorWiseProgressReport(params)
      .then((res) => { setSubTableEnb(false); setSubDistTableEnb(false); setmaintablenb(true);
          
        if (res.data && res.data.SCODE == "01") { setData(res.data.SDESC); } else { showAlertMessage(res.data.SDESC,"warning");setData([]); }
       
      }).catch(() => { showAlertMessage("Failed to fetch data. Please try again.", "warning"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };

const DistrictWiseData = (dept_id) => { setselecteddept(dept_id);

  const params = {
    year: formik.values.year,
    userId: username,
    deptId: dept_id,
    buttonType: "sub",
    districtId: district,
    entryLevel: formik.values.entry_level,
    mandalId:"0",
    monthOrder:formik.values.month

  };

  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.indicatorWiseProgressReport(params)
    .then((res) => {
      setSubDistTableEnb(true);
      setmaintablenb(false);
      setSubTableEnb(false);

      if (res.data && res.data.SCODE === "01") {
       setsubDistTableData(res.data.SDESC)
      } else { showAlertMessage(res.data.SDESC,"warning");
        setsubDistTableData([]);
      }
    })
    .catch(() => {
      showAlertMessage("Failed to fetch data. Please try again.", "warning");
    })
    .finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });
};



const mandalWiseData = (dept_id, districtt) => { setselecteddept(dept_id);
  let params = {
    
        year: formik.values.year,
    userId: username,
    deptId: dept_id,
    buttonType: "sub",
    districtId:roleid === "112" ? district:districtt?.toString(),
    entryLevel: formik.values.entry_level,
    mandalId:"0",
    ...(roleid === "112" ? {constId:assembleid}:{}),
    monthOrder:formik.values.month


  };

  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.indicatorWiseProgressReport(params)
   
    .then((res) => {
     setSubTableEnb(true);
      setmaintablenb(false);
      setSubDistTableEnb(false);

      if (res.data && res.data.SCODE === "01") {
       setSubTableData(res.data.SDESC)
      } else {  showAlertMessage(res.data.SDESC,"warning");setSubTableData([]); }
    }) .catch(() => { showAlertMessage("Failed to fetch data. Please try again.", "warning"); }) .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
};

const modalsclose=()=>{ setTargetMandalEnb(false);setAchMandalEnb(false);
  setSearch("");setSearchsub("");setSearchdistsub("");setsearchPendingAchText("");setsearchTargetsText("");setsearchTargetNamesText("");setsearchAchNamesText("")
 }
const handleTargetcountClose =()=>{
  setTargetCountEnb(false);
  
  modalsclose();setEnteredAchEnb(false);
}

const handlePendingAchClose =()=>{
  setPendingAchEnb(false);
  modalsclose();setEnteredAchEnb(false);
}

const TargetCountData = (type,entryy,dept_id,districtt,mandalll)=>{
  
  setDrillType(type);
setEntry(entryy);
 setselecteddept(dept_id);
modalsclose();
setTargetNames([]);
  const params = {
    year: formik.values.year,
    userId: username,
    deptId: dept_id,
    buttonType:((type === "Mandal"|| ["111","117"].includes(roleid)) && entryy === "mandalLevel") ? "TargetsMandal":(type !== "Mandal" && entryy === "mandalLevel")? "TargetsSubMandal":"TargetsSub",
    districtId: roleid === "112" ? district:districtt,
    entryLevel: entryy,
    mandalId:mandalll,
    ...(roleid === "112" ? {constId:assembleid}:{})
    
  };

  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.indicatorWiseProgressReport(params)
    .then((res) => {
        // if(type === "HOD"){setmaintablenb(false)}if(type === "District"){setSubDistTableEnb(false)}
        //     if(type === "Mandal"){setSubTableEnb(false)};
  

      if (res.data && res.data.SCODE === "01") {
       setTargetsData(res.data.SDESC);
      //  setTargetNamesEnb(false);
  setTargetCountEnb(true);
      } else { showAlertMessage(res.data.SDESC,"warning");
        setTargetsData([]);
setTargetNames([]);
      }
    })
    .catch(() => {
      showAlertMessage("Failed to fetch data. Please try again.", "warning");
    })
    .finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });



}

const TargetmandalCountData = (dist)=>{
// setTargetMandalEnb(true);
 setTargetNames([]);
  const params = {
    year: formik.values.year,
    userId: username,
    deptId: selecteddept,
    buttonType: "Targets",
    districtId: dist,
    entryLevel: Entry,
    mandalId:"0",
    ...(roleid === "112" ? {constId:assembleid}:{})
    
  };

  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.indicatorWiseProgressReport(params)
    .then((res) => {
       setTargetMandalEnb(true);
      if (res.data && res.data.SCODE === "01") {
       setTargetsmandalData(res.data.SDESC);
  
      } else {
        setTargetsmandalData([]);


      }
    })
    .catch(() => {
      showAlertMessage("Failed to fetch data. Please try again.", "warning");
    })
    .finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });



}
const AchievementmandalCountData = (dist)=>{
 setAchievementNamesdata([]);
  const params = {
    year: formik.values.year,
    userId: username,
    deptId: selecteddept,
    buttonType: "Achvemt",
    districtId: roleid === "112" ? district:dist,
    entryLevel: Entry,
    mandalId:"0",
    headId:Head_id,
    ...(roleid === "112" ? {constId:assembleid}:{})
    
  };

  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.indicatorWiseProgressReport(params)
    .then((res) => {
       setAchMandalEnb(true);
      if (res.data && res.data.SCODE === "01") {
       setAchmandalData(res.data.SDESC);
  
      } else {
        setAchmandalData([]);


      }
    })
    .catch(() => {
      showAlertMessage("Failed to fetch data. Please try again.", "warning");
    })
    .finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });



}
const TargetNamesData = (districtt,mandall)=>{
setTargetNames([]);

  const params = {
    year: formik.values.year,
    userId: username,
    deptId: selecteddept,
    buttonType: (Entry === "mandalLevel") ? "TargetsFinalMandal":"TargetsFinal",
    districtId: roleid === "112" ? district:districtt,
    entryLevel: Entry,
    mandalId:mandall,
    ...(roleid === "112" ? {constId:assembleid}:{})

  };

  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.indicatorWiseProgressReport(params)
    .then((res) => {
      
      if (res.data && res.data.SCODE === "01") {
       setTargetNames(res.data.SDESC);
      
      } else { showAlertMessage(res.data.SDESC,"warning");
        setTargetNames([]);
      }
    })
    .catch(() => {
      showAlertMessage("Failed to fetch data. Please try again.", "warning");
    })
    .finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });

}
const PendingAchCountData = (type,entryy,dept_id,districtt,mandalll,enb,head)=>{
modalsclose();
  setEnteredAchEnb(enb);
  setDrillType(type);
setEntry(entryy);
setHead(head.toString());
 setselecteddept(dept_id);
  setAchievementNamesdata([]);
  setPendingmandalData([]);
  setPendingmandalenb(false);
  const params = {
    year: formik.values.year,
    userId: username,
    deptId: dept_id,
    buttonType:((type === "Mandal" && entryy === "mandalLevel") ||["111","117"].includes(roleid)) ? "AchvemtsMandal":(type !== "Mandal" && entryy === "mandalLevel") ? "AchvemtSubMandal":"AchvemtSub",
    districtId: roleid === "112" ? district:districtt,
    entryLevel: entryy,
    mandalId:mandalll,
    headId:head.toString(),
    ...(roleid === "112" ? {constId:assembleid}:{})

    
  };

  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.indicatorWiseProgressReport(params)
    .then((res) => {
   

      if (res.data && res.data.SCODE === "01") {
        if(entryy==="mandalLevel"){
         const finalData = res.data.SDESC?.filter(detail =>
      enb
        ? detail.mandal_count !== 0              
        : detail.pending_mandal_count !== 0        
    );
       setPendingAChievementData(finalData);
        }
  else{
       const finalData = res.data.SDESC?.filter(detail =>
      enb
        ? detail.district_id !== null              
        : detail.pending_indicators >0     
    );
       setPendingAChievementData(finalData);

  }
  // setAchievementNamesEnb(false);
  setPendingAchEnb(true);

      } 
      else { showAlertMessage(res.data.SDESC,"warning");
        setPendingAChievementData([]);
  setAchievementNamesdata([]);

      }
    }
  )
    .catch(() => { showAlertMessage("Failed to fetch data. Please try again.", "warning"); })
    .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });



}

const IndicatorNamesData = (districtt,mandall)=>{

        setAchievementNamesdata([]);

  const params = {
    year: formik.values.year,
    userId: username,
    deptId: selecteddept,
    buttonType:(Entry === "mandalLevel") ? "AchvemtFinalMandal":"AchvemtFinal",
    districtId: roleid === "112" ? district:districtt,
    entryLevel: Entry,
    mandalId:mandall,
    headId:Head_id.toString(),
    ...(roleid === "112" ? {constId:assembleid}:{})

  };

  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.indicatorWiseProgressReport(params)
    .then((res) => {
      
      if (res.data && res.data.SCODE === "01") {
        const finalData = res.data.SDESC?.filter(detail =>
      EnteredAchEnb
        ? detail.status_id !== 0              
        : detail.status_id === 0        
    );
      
      setAchievementNamesdata(finalData);

      } else { 
        setAchievementNamesdata([]);
      }
    })
    .catch(() => {
      showAlertMessage("Failed to fetch data. Please try again.", "warning");
    })
    .finally(() => {
      store.dispatch({ type: "HIDE_SPINNER" });
    });

}


const EnterednAchCountData = (type,entryy,dept_id,districtt,mandalll)=>{
  
//   setDrillType(type);
// setEntry(entryy);
//  setselecteddept(dept_id);
//   const params = {
//     year: formik.values.year,
//     userId: username,
//     deptId: dept_id,
//     buttonType:"IndicatorsSub",
//     districtId: districtt,
//     entryLevel: formik.values.entry_level,
//     mandalId:mandalll
    
//   };

//   store.dispatch({ type: "SHOW_SPINNER" });

//   KpiService.indicatorWiseProgressReport(params)
//     .then((res) => {
        
//    setTargetNamesEnb(false);
//   setTargetCountEnb(false);

//       if (res.data && res.data.SCODE === "01") {
//        setPendingAChievementData(res.data.SDESC);
//        setinddistData(res.data.SDESC);      
//   setAchievementNamesEnb(false);
//   setPendingAchEnb(true);

//       } else { showAlertMessage(res.data.SDESC,"warning");
//         setPendingAChievementData([]);
//         setinddistData([]);

//       }
//     })
//     .catch(() => {
//       showAlertMessage("Failed to fetch data. Please try again.", "warning");
//     })
//     .finally(() => {
//       store.dispatch({ type: "HIDE_SPINNER" });
//     });



}
  const filteredData = searchText.length > 0 && data?.length ? data.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()); }) ); }) : data;
 const filtereddistData =
    searchdistSub.length > 0 && subDistTableData?.length
      ? subDistTableData.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchdistSub.toLowerCase()); }) );
        })
      : subDistTableData;
const filteredDataSub =
    searchSub.length > 0 && subTableData?.length
      ? subTableData.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchSub.toLowerCase()); }) );
        })
      : subTableData;


  const filteredTargetsData = searchTargetsText.length > 0 && TargetsData?.length ? TargetsData.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchTargetsText.toLowerCase()); }) ); }) : TargetsData;
  const filteredmandalTargetsData = searchmandalTargetsText.length > 0 && TargetsmandalData?.length ? TargetsmandalData.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchmandalTargetsText.toLowerCase()); }) ); }) : TargetsmandalData;
  const filteredmandalAchsData = searchmandalAchText.length > 0 && AchmandalData?.length ? AchmandalData.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchmandalAchText.toLowerCase()); }) ); }) : AchmandalData;
  
  const filteredTargetNamesData = searchTargetNamesText.length > 0 && TargetNames?.length ? TargetNames.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchTargetNamesText.toLowerCase()); }) ); }) : TargetNames;
  
  const filteredAchievementsData = searchPendingAchText.length > 0 && PendingAChievementData?.length ? PendingAChievementData.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchPendingAchText.toLowerCase()); }) ); }) : PendingAChievementData;
  const filteredAchievementnamessData = searchAchNamesText.length > 0 && AchievementNamesdata?.length ? AchievementNamesdata.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchAchNamesText.toLowerCase()); }) ); }) : AchievementNamesdata;
 
const hodenb=(id)=>{
  
     formik.setFieldValue("year","");formik.setFieldValue("entry_level","");formik.setFieldValue("month","");
    setData([]);
}
 
  const headerStyle = { backgroundColor: "#4e835c", color: "white", padding: "5px", border: "1px solid white",wordBreak: "break-word" };

const emptyData=()=>{
  setData([]);
 setSubTableData([]);setSubDistTableEnb(false);setSubTableEnb(false)
setsubDistTableData([]);}

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "96%" }}> <div className="sa-title"> <h2> Indicator Wise <span>Progress Report </span> </h2> </div> </Container>
      <Container fluid style={{ width: "96%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
           
            <div className="py-2 px-4 mb-3">
              <Row>
    


                 <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                                  <label htmlFor="department_id" className="mb-1 fw-bold"> {" "} HOD Name </label>
                                                                       {/* <Select className="w-100" isClearable={true} isSearchable={true} name="department_id" required={true} getOptionValue={(option) => option.dept_id}
                                                                        getOptionLabel={(option) => option.dept_name} options={Deptlist} 
                                                                        value={Deptlist?.find((option) => option.dept_id === formik.values.department_id) || ""} onChange={(option) => { formik.setFieldValue("department_id",option ? option.dept_id : "");hodenb(option ? option.dept_id : "");emptyData()  }} isDisabled={["113","114","111"].includes(roleid) ? true:false} menuPortalTarget={document.body} styles={{ menuPortal: (base) => ({ ...base, zIndex: 1000 }), }} />
                                   */}

                                   <Select
  {...commonSelectProps({
    name: "department_id",
    options: Deptlist,
    value: formik.values.department_id,
    optionValueKey: "dept_id",
    optionLabelKey: "dept_name",
    formik,
    isDisabled: ["113", "114", "111","115"].includes(roleid),

    extraOnChange: (option) => {
      hodenb(option ? option.dept_id : "");
      emptyData();
    }
  })}
/>

                                </Col>
                 {["113","119","117","111"].includes(roleid) &&
                                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">District</label> 
                                                      <Select
  {...commonSelectProps({
    name: "district_id",
    options: distlist,
    value: formik.values.district_id,
    optionValueKey: "id",
    optionLabelKey: "value",
    formik,
    isDisabled: true,

    extraOnChange: (option) => {
    }
  })}
/>                      
                                                             
                                    </Col>
                                   } 

              {roleid === "112" &&
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  >
                  <label className="mb-1 fw-bold"> Constituency </label> <span style={{ color: "red" }}> *</span>
                                           <Field type="text" name="constid" style={{ fontWeight: "bold" }}className="mb-3 form-control"  value={localStorage.getItem("assemblyname")} disabled/>
                </Col>
}
                                   {["117","111"].includes(roleid) &&
                                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='district-select'> <label className="mb-1 fw-bold">{ulbdeptlist.includes(roleid === "111"?deptId:formik.values.department_id)?"ULB":"Mandal"}</label> 
                                   
                                   <Field className="mb-3 form-control" name="mandal_id" type="text"  value={selectedmandal}  controlId="formBasicEmail" 
                                   disabled={true} style={{ fontWeight: "bold" }}/>
                                     </Col>
                                   } 
                                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                                                     <label className="mb-1 fw-bold"> Financial Year </label> <span style={{ color: "red" }}> *</span>
                                                    <Select
  {...commonSelectProps({ name: "year", options: yearList, value: formik.values.year,
   optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: false, extraOnChange: (option) => { formik.setFieldValue("entry_level",""); setData([]);setsubDistTableData([]);setSubTableData([]); } })}
/>   
                                                   </Col>
                                                    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                                                     <label className="mb-1 fw-bold"> Month</label> <span style={{ color: "red" }}> *</span>
                                                    <Select {...commonSelectProps({ name: "month", options: monthList, value: formik.values.month, optionValueKey: "month_order", optionLabelKey: "month_name", formik, isDisabled: false,
extraOnChange: (option) => { formik.setFieldValue("entry_level","");
setData([]);setsubDistTableData([]);setSubTableData([]);} })} />   
                                                   </Col>
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'> <label className="mb-1 fw-bold"> Entry Level </label>
                 <span style={{ color: "red" }}> *</span>
                  <Select
  {...commonSelectProps({
    name: "entry_level",
    options: entryLevelOptions,
    value: formik.values.entry_level,
    optionValueKey: "value",
    optionLabelKey: "label",
    formik,
    isDisabled: false,

    extraOnChange: (option) => {
      
      getData(option? option.value:"");
    }
  })}
/>   
                 
                  </Col>
              
              </Row> </div> </Form> </FormikProvider>

        {maintablenb && <>
        <Row>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
            
            <div style={{ alignItems: "center",display: "flex",  border: "1px solid #ddd", borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container">
              
              <AiOutlineSearch className="me-2" style={{ color: "#888", fontSize: "1.2rem", visibility: "visible" }} />
              <input type="text" value={searchText}
              placeholder="Search"   onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onChange={(e) => setSearch(e.target.value)}onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
            </div>
          </Col>
          <Col className="mb-2">
           {/*<button className="btn btn-danger btn-sm mx-2 pdf-btn"  style={{ float: "right", marginLeft: "3px" }} onClick={() => generatePdf("#my-table", "indicatorWiseProgressReport",76)} > PDF <MdOutlinePictureAsPdf /> </button>*/}
           <button size="sm" className="btn mx-2 excel-btn"  
           onClick={() => exportToExcel("my-table", "indicatorWiseProgressReport")} style={{ float: "right", color: "#ffffff", marginLeft: "3px" }}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
         
          </Col>
        </Row>
<div
  style={{ textAlign: "center", backgroundColor: "#d4e3d8" }}
  className="rounded-1 border py-1"
>
  <span className="style">
    Indicator Wise{" "}
    {["113", "119", "111", "117"].includes(roleid) && (
      <>
        <span style={{ color: "rgb(214 136 21)" }}>{selecteddist}</span> District{" "}

        {["111", "117"].includes(roleid) && (
          <>
            <span style={{ color: "rgb(214 136 21)" }}>{selectedmandal}</span> {ulbdeptlist.includes(roleid ==="111"?deptId:formik.values.department_id)?"ULB":"Mandal"}{" "}
          </>
        )}
      </>
    )}
    {["112"].includes(roleid) && (
      <>
        <span style={{ color: "rgb(214 136 21)" }}>{localStorage.getItem("assemblyname")}</span> Constituency{" "}
      </>
    )}
    Progress Report
  </span>

  <div className="text-end style-1">
    Report On : {currentdate} {currenttime}
  </div>
</div>

        <div id="table-scroll" className="table-scroll">
          <div className="table-wrap">
       <Table bordered id="my-table" className="custom-table table-responsive table table-bordered sticky-table">

  
  <thead>
   
    <tr className="text-center only-export">
      <th colSpan={82} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}>
        Indicator Wise- {["113","119","111","117"].includes(roleid)?`${selecteddist} District ${["111","117"].includes(roleid)?`${selectedmandal} ${ulbdeptlist.includes(roleid ==="111"?deptId:formik.values.department_id)?"ULB":"Mandal"}`:""}`:""} 
        {["112"].includes(roleid) && `${localStorage.getItem("assemblyname")} Constituency`}
         Progress Report
      </th>
    </tr>

    <tr className="text-center">
      <th style={headerStyle} className="sticky-col sticky-sno" rowSpan={3}>Sl.No.</th>
      <th className="sticky-col sticky-KPIHOD indicator-column" style={{ ...headerStyle, minWidth: "200px" }} rowSpan={3}>HOD Name</th>

      <th style={headerStyle} colSpan={7} className="sticky-col sticky-KPIPERIODIC">Periodicity</th>

      <th style={headerStyle} rowSpan={3} className="sticky-col sticky-KPIENTRYLEVEL">Entry Level</th>
      <th style={headerStyle} rowSpan={3} className="sticky-col sticky-KPITOTAL">Total <br />No.of Targets</th>
      <th style={headerStyle} colSpan={7} className="sticky-col sticky-KPIINDICATORS">No.of Indicators <br/>Targets Provided</th>

      <th style={headerStyle} colSpan={allPeriods.length * 4}>
        No.of Indicators Achievements Provided
      </th>
    </tr>

    <tr className="text-center">
       {[ "M.ly", "Q.ly", "H.ly", "A.ly", "Bie.", "5 yrs", "Total", ].map((label) => ( <th key={label} style={headerStyle} rowSpan={2} className={`sticky-col sticky-${label === "Total" ? "Totalll":label.replace(/[^a-zA-Z0-9_-]/g, "")}`}> {label} </th> ))  }
{[
  "M.ly", 
  "Q.ly", 
  "H.ly", 
  "A.ly", 
  "Bie.", 
  "5 yrs", 
  "Total"
].map((label) => {
  const safeClass = label === "Total" 
    ? "tarTotalll" 
    : `tar${label.replace(/[^a-zA-Z0-9_-]/g, "")}`;

  return (
    <th
      key={label}
      style={headerStyle}
      rowSpan={2}
      className={`sticky-col sticky-${safeClass}`}
    >
      {label}
    </th>
  );
})}

      {/* {[ { name: "April", order: 4 }, { name: "May", order: 5 }, { name: "June/Q1", order: 6 }, { name: "July", order: 7 }, { name: "Aug", order: 8 }, { name: "Sept/Q2/HY1", order: 9 }, { name: "Oct", order: 10 }, { name: "Nov", order: 11 }, { name: "Dec/Q3", order: 12 }, { name: "Jan", order: 1 }, { name: "Feb", order: 2 }, { name: "Mar/Q4/HY2/Annual", order: 3 }, { name: "Bi Ennial", order: 13 }, { name: "5 year", order: 14 }, ].map((period) => ( <th key={period.name} style={headerStyle} colSpan={4}> {period.name} </th> ))} */}
    {filteredPeriods.map((period) => (
  <th key={period.name} style={headerStyle} colSpan={4}>
    {period.name}
  </th>
))}
    </tr>

    <tr className="text-center">
      {filteredPeriods.map((period) => (
  <React.Fragment key={period}>
          <th style={headerStyle}>Achievements <br />
          {`${!["113","117","112"].includes(roleid) ? "District/Mandal":"Mandal"}`} <br/>Count</th> <th style={headerStyle}>Pending <br />Achievements <br/>{`${!["113","117","112"].includes(roleid) ? "District/Mandal":"Mandal"}`}<br />Count</th> <th style={headerStyle}>Achievements <br />Indicators <br />Count</th> <th style={headerStyle}>Pending <br />Indicators <br />Count</th>
        </React.Fragment>
))}
      {/* {[ "April", "May", "June/Q1", "July", "Aug", "Sept/Q2/HY1", "Oct", "Nov", "Dec/Q3", "Jan", "Feb", "Mar/Q4/HY2/Annual", "Bi Ennial", "5 year" ].map((period) => ( 
        <React.Fragment key={period}>
          <th style={headerStyle}>Achievements <br />Count</th> <th style={headerStyle}>Pending <br />Achievements <br />Count</th> <th style={headerStyle}>Achievements <br />Indicators <br />Count</th> <th style={headerStyle}>Pending <br />Indicators <br />Count</th>
        </React.Fragment>
      ))} */}
    </tr>
  </thead>

 <tbody>
  {filteredData?.length === 0 || filteredData === undefined ? (
    <tr>
      <td className="text-center" colSpan={82}>
        <b style={{ color: "red" }}>Details Not Found</b>
      </td>
    </tr>
  ) : (
    (() => {
      let slno = 0;

      const groupedByDept = {};
      filteredData.forEach((item) => {
        const key = item.dept_id;
        if (!groupedByDept[key]) groupedByDept[key] = [];
        groupedByDept[key].push(item);
      });

      return Object.entries(groupedByDept).flatMap(([deptId, deptRows]) => {
        const firstDeptRow = deptRows[0];
        const deptName = firstDeptRow.dept_name;

        const groupedByEntryType = {};
        deptRows.forEach((item) => {
          const key = item.entry_type || "Unknown";
          if (!groupedByEntryType[key]) groupedByEntryType[key] = [];
          groupedByEntryType[key].push(item);
        });

        const entryTypes = Object.keys(groupedByEntryType);
        const deptRowSpan = entryTypes.length;
        const hasMandalEntry =["113", "119","112"].includes(roleid) ?entryTypes.includes("Mandal"):
          entryTypes.includes("Mandal") || entryTypes.includes("District");

        slno += 1;

        return entryTypes.map((entryType, idx) => {
          const rows = groupedByEntryType[entryType];
          const first = rows[0];

          const getMonthData = (monthOrder) =>
            rows.find((r) => parseInt(r.month_order) === monthOrder) || {};

          return (
            <tr key={`${deptId}-${entryType}`}>
              {idx === 0 && (
                <td
                  className="sticky-col sticky-sno"
                  rowSpan={deptRowSpan}
                  style={{ textAlign: "center" }}
                >
                  {slno}
                </td>
              )}

              {idx === 0 && (
                <td
                  className="sticky-col sticky-KPIHOD indicator-column"
                  style={
                    !["111","117"].includes(roleid)&& hasMandalEntry
                      ? {
                          textAlign: "left",
                          verticalAlign: "middle",
                          color: "blue",
                          cursor: "pointer",
                        }
                      : { textAlign: "left", verticalAlign: "middle" }
                  }
                  onClick={
                    !["111","117"].includes(roleid)&&hasMandalEntry
                      ? () => {
                        
                          if (["113", "119","112"].includes(roleid)) {
                            mandalWiseData(firstDeptRow.dept_id, firstDeptRow.district_id);
                            setselecteddist(firstDeptRow.district_name);
                          } else {
                            DistrictWiseData(firstDeptRow.dept_id);
                          }
                        }
                      : undefined
                  }
                  rowSpan={deptRowSpan}
                >
                  {`${firstDeptRow.hod_id}-${deptName}`}
                </td>
              )}

              <td style={{ textAlign: "right" }} className="sticky-col sticky-Mly">{first.ind_m_count || 0}</td> <td style={{ textAlign: "right" }} className="sticky-col sticky-Qly">{first.ind_q_count || 0}</td>
               <td style={{ textAlign: "right" }} className="sticky-col sticky-Hly">{first.ind_h_count || 0}</td> <td className="sticky-col sticky-Aly"style={{ textAlign: "right" }}>{first.ind_a_count || 0}</td>
                <td style={{ textAlign: "right" }} className="sticky-col sticky-Bie">{first.ind_b_count || 0}</td> <td className="sticky-col sticky-5yrs" style={{ textAlign: "right" }}>{first.ind_f_count || 0}</td> <td style={{ textAlign: "right" }} className="sticky-col sticky-Totalll">{first.ind_t_count || 0}</td>


              <td style={{ textAlign: "left" }} className="sticky-col sticky-KPIENTRYLEVEL" > {first.entry_type || ""} </td>

              <td
                 style={ ((first.target_counts && first.ac_entrylevel !== "secretariatLevel" && first.entry_type !== "HOD")||((first.ac_entrylevel=== "hodLevel"|| first.ac_entrylevel === "secretariatLevel") && hasMandalEntry && !["111", "117"].includes(roleid) &&first.target_counts)) ? { textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer", } : { textAlign: "right", verticalAlign: "middle" } }
                className="sticky-col sticky-KPITOTAL"
                 onClick={() => {
    if (!first.target_counts) return;

    if ((first.ac_entrylevel=== "hodLevel" || first.ac_entrylevel === "secretariatLevel")) {
      if (!["111", "117"].includes(roleid) && hasMandalEntry) {
        if (["113", "119","112"].includes(roleid)) {
          mandalWiseData(firstDeptRow.dept_id, firstDeptRow.district_id);
          setselecteddist(firstDeptRow.district_name);
        } else {
          DistrictWiseData(firstDeptRow.dept_id);
        }
      }
    }

    else {
      
      TargetCountData("HOD", first.ac_entrylevel, firstDeptRow.dept_id, firstDeptRow.district_id? firstDeptRow.district_id:"0", firstDeptRow.mandal_id? firstDeptRow.mandal_id:"0");
      
    }
  }}
                // onClick={() => first.target_counts ? TargetCountData("HOD",first.entry_type,firstDeptRow.dept_id, "0","0") :"" }
              >
                {first.target_counts || 0}
              </td>
               <td style={{ textAlign: "right" }} className="sticky-col sticky-tarMly">{first.tr_m_count || 0}</td> <td style={{ textAlign: "right" }} className="sticky-col sticky-tarQly">{first.tr_q_count || 0}</td>
               <td style={{ textAlign: "right" }} className="sticky-col sticky-tarHly">{first.tr_h_count || 0}</td> <td className="sticky-col sticky-tarAly"style={{ textAlign: "right" }}>{first.tr_a_count || 0}</td>
                <td style={{ textAlign: "right" }} className="sticky-col sticky-tarBie">{first.tr_b_count || 0}</td> <td className="sticky-col sticky-tar5yrs" style={{ textAlign: "right" }}>{first.tr_f_count || 0}</td> <td style={{ textAlign: "right" }} className="sticky-col sticky-tarTotalll">{first.tr_ind_count || 0}</td>


{/* {[4,5,6,7,8,9,10,11,12,1,2,3,13,14].map(order => { */}
{filteredPeriods.map(period => {
  const order = period.order;
  const m = getMonthData(order);

  const monthHeadMap = {
    6: ["8","15"],
    9: ["11","16","1"],
    12: ["14","17"],
    3: ["5","18","2","0"],
  };

  const getHeadIds = (fieldName) => {
    let headIds = monthHeadMap[order] ? [...monthHeadMap[order]] : [m.head_id];
    // if (order === 6) {
    //   const main = rows.find(r => parseInt(r.month_order) === 6 && r.head_id !== "15");
    //   if (main) headIds.unshift(main.head_id);
    // }
    return headIds;
  }

const getValues = (fieldName) => {
  return getHeadIds(fieldName).map(hid => {
    const row = rows.find(r => parseInt(r.month_order) === order && r.head_id === hid);
    return row?.[fieldName] || 0;
  });
}


  const getCellStyle = (totalValue) =>
    ((totalValue > 0 && first.ac_entrylevel !== "secretariatLevel" && first.entry_type !== "HOD") ||
     ((first.ac_entrylevel === "hodLevel" || first.ac_entrylevel === "secretariatLevel") &&
      hasMandalEntry && !["111","117"].includes(roleid) && totalValue > 0))
      ? { textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer" }
      : { textAlign: "right", verticalAlign: "middle" };

  const handleClick = (value, headId, isAcCount=false) => {
    if(value > 0){
      if(first.ac_entrylevel==="hodLevel"||first.ac_entrylevel==="secretariatLevel"){
        if(!["111","117"].includes(roleid)&&hasMandalEntry){
          if(["113","119","112"].includes(roleid)){
            mandalWiseData(firstDeptRow.dept_id,firstDeptRow.district_id);
            setselecteddist(firstDeptRow.district_name);
          } else {
            DistrictWiseData(firstDeptRow.dept_id);
          }
        }
      } else {
        PendingAchCountData(
          "HOD",
          first.ac_entrylevel,
          firstDeptRow.dept_id,
          firstDeptRow.district_id || "0",
          firstDeptRow.mandal_id || "0",
          isAcCount,
          headId
        );
      }
    }
  }

  const renderCell = (fieldName, isAcCount=false) => {
    const values = getValues(fieldName);
    const headIds = getHeadIds(fieldName);
    const total = values.reduce((a,b)=>a+b,0);

  return (
  <td style={{ textAlign: "right" }}>
    {values.map((val, i) => (
      val > 0 ? (
        <span
          key={headIds[i]}
          role="button"
          tabIndex={0}
          style={{ cursor: "pointer", color: "blue" }}
          onClick={() => handleClick(val, headIds[i], isAcCount)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleClick(val, headIds[i], isAcCount);
            }
          }}
        >
          {val}{i < values.length - 1 ? " / " : ""}
        </span>
      ) : (
        <span key={headIds[i]}>
          {val}{i < values.length - 1 ? " / " : ""}
        </span>
      )
    ))}
  </td>
);

  }

  return (
   <React.Fragment key={order}>
  {/* Clickable cells */}
  {renderCell("ac_counts", true)}
  {renderCell("ac_pending_count")}

  {/* Non-clickable cells */}
  <td style={{ textAlign: "right", verticalAlign: "middle" }}>
    {getValues("ac_ind_count").join(" / ")}
  </td>
  <td style={{ textAlign: "right", verticalAlign: "middle" }}>
    {getValues("ac_pending_ind_count").join(" / ")}
  </td>
</React.Fragment>

  )
})}



            </tr>
          );
        });
      });
    })()
  )}
</tbody>

</Table>


          </div>
        </div> </>}
        
        {SubDistTableEnb && 
        <>
          <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> 
            <div style={{ display: "flex", border: "1px solid #ddd",alignItems: "center",  borderRadius: "20px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchdistSub} onChange={(e) => setSearchdistsub(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2">
            <button size="sm" className="btn mx-2 excel-btn" style={{ color: "#ffffff",float: "right",  marginLeft: "3px" }} onClick={() => exportToExcel("my-table1", "indicatorWiseProgressReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
            <button type="button" size="sm" className="btn btn-warning btn-sm mx-2 warn-btn" style={{ marginLeft: "3px", float: "right" }} onClick={()=>{setSubTableEnb(false);setSubTableData([]);setSubDistTableEnb(false);setsubDistTableData([]);setmaintablenb(true);setSearch("");setSearchsub("");setSearchdistsub("");setsearchPendingAchText("");setsearchTargetsText("");setsearchTargetNamesText("");setsearchAchNamesText("")}}> <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button> </Col> </Row>

         <div style={{backgroundColor: "#d4e3d8", textAlign: "center" }} className="rounded-1 border py-1"> <span className="style"> Indicator Wise {subDistTableData[0]?.dept_name && ( <span style={{ color: "rgb(214 136 21)" }}> {subDistTableData[0]?.dept_name}</span> )} Progress</span> <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div> </div>
        <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
    
<Table bordered id="my-table1" className="table table-bordered custom-table table-responsive sticky-table"> <thead>
          
          <tr className="text-center only-export"> <th colSpan={76} style={{ backgroundColor: "#d4e3d8", textAlign: "center" }} > Indicator Wise {subDistTableData[0]?.dept_name ? subDistTableData[0]?.dept_name:""} Progress Report </th> </tr>

          <tr className="text-center">
            <th style={headerStyle} className="sticky-col sticky-sno" rowSpan={3} > Sl.No. </th> <th className="sticky-col sticky-KPIHOD indicator-column" style={{ ...headerStyle, minWidth: "200px" }} rowSpan={3} > District Name </th>

            

            <th style={headerStyle} colSpan={7} className="sticky-col sticky-KPIPERIODIC"> Periodicity </th> <th style={headerStyle} className="sticky-col sticky-KPIENTRYLEVEL"rowSpan={3}> Entry Level </th>
            <th style={headerStyle} rowSpan={3} className="sticky-col sticky-KPITOTAL"> Total <br /> No.of Targets </th> <th className="sticky-col sticky-KPIINDICATORS" style={headerStyle} rowSpan={3}> No.of Indicators <br /> Targets Provided </th>

            <th style={headerStyle} colSpan={14 * 4}>
              No.of Indicators Achievements Provided
            </th>
          </tr>

          <tr className="text-center"> {[ "M.ly", "Q.ly", "H.ly", "A.ly", "Bie.", "5 yrs", "Total", ].map((label) => ( <th key={label} style={headerStyle} rowSpan={2} className={`sticky-col sticky-${label === "Total" ? "Totalll":label.replace(/[^a-zA-Z0-9_-]/g, "")}`}> {label} </th>
            ))}

            {/* {[
              { name: "April", order: 4 }, { name: "May", order: 5 }, { name: "June/Q1", order: 6 }, { name: "July", order: 7 }, { name: "Aug", order: 8 }, { name: "Sept/Q2/HY1", order: 9 }, { name: "Oct", order: 10 }, { name: "Nov", order: 11 }, { name: "Dec/Q3", order: 12 }, { name: "Jan", order: 1 }, { name: "Feb", order: 2 }, { name: "Mar/Q4/HY2/Annual", order: 3 }, { name: "Bi Ennial", order: 13 }, { name: "5 year", order: 14 },
            ].map((period) => (
              <th key={period.name} style={headerStyle} colSpan={4}>
                {period.name}
              </th>
            ))} */}
             {filteredPeriods.map((period) => 
             (
  <th key={period.name} style={headerStyle} colSpan={4}> {period.name} </th> ))}
          </tr>

          <tr className="text-center">
            {/* {[
              "April", "May", "June/Q1", "July", "Aug", "Sept/Q2/HY1", "Oct", "Nov", "Dec/Q3", "Jan", "Feb", "Mar/Q4/HY2/Annual", "Bi Ennial", "5 year",
            ].map((period) => (
              <React.Fragment key={period}>
                <th style={headerStyle}> Achievements <br /> Count </th> <th style={headerStyle}> Pending <br /> Achievements <br /> Count </th>
                <th style={headerStyle}> Achievements <br /> Indicators <br /> Count </th> <th style={headerStyle}> Pending <br /> Indicators <br /> Count </th>
              </React.Fragment>
            ))} */}
               {filteredPeriods.map((period) => 
               (
  <React.Fragment key={period}> <th style={headerStyle}>Achievements <br />{`${!["113","117","112"].includes(roleid) ? "District/Mandal":"Mandal"}`} <br/>Count</th> <th style={headerStyle}>Pending <br />Achievements <br/>{`${!["113","117","112"].includes(roleid) ? "District/Mandal":"Mandal"}`}<br />Count</th> <th style={headerStyle}>Achievements <br />Indicators <br />Count</th> <th style={headerStyle}>Pending <br />Indicators <br />Count</th> </React.Fragment> ))}
          </tr>
        </thead>


 <tbody>
  {filtereddistData?.length === 0 || filtereddistData === undefined ? (
    <tr>
      <td className="text-center" colSpan={76}>
        <b style={{ color: "red" }}>Details Not Found</b>
      </td>
    </tr>
  ) : (
    (() => {
      let slno = 0;

      const groupedByDist = {};
      filtereddistData.forEach((item) => {
        const key = item.district_id;
        if (!groupedByDist[key]) groupedByDist[key] = [];
        groupedByDist[key].push(item);
      });

      return Object.entries(groupedByDist).flatMap(([distId, distRows]) => {
        const firstDistRow = distRows[0];
        const districtName = firstDistRow.district_name;

        const groupedByEntryType = {};
        distRows.forEach((item) => {
          const key = item.entry_type || "Unknown";
          if (!groupedByEntryType[key]) groupedByEntryType[key] = [];
          groupedByEntryType[key].push(item);
        });

        const entryTypes = Object.keys(groupedByEntryType);
        const distRowSpan = entryTypes.length;

        const hasMandalEntry = entryTypes.includes("Mandal");

        slno += 1;

        return entryTypes.map((entryType, idx) => {
          const rows = groupedByEntryType[entryType];
          const first = rows[0];

          const getMonthData = (monthOrder) =>
            rows.find((r) => parseInt(r.month_order) === monthOrder) || {};

          return (
            <tr key={`${distId}-${entryType}`}>
              {idx === 0 && ( <td className="sticky-col sticky-sno" style={{ textAlign: "center" }} rowSpan={distRowSpan} > {slno} </td> )}

              {idx === 0 && ( <td className="sticky-col sticky-KPIHOD indicator-column" style={ hasMandalEntry ? { textAlign: "left", verticalAlign: "middle", color: "blue", cursor: "pointer", } : { textAlign: "left", verticalAlign: "middle" } } rowSpan={distRowSpan} onClick={() => { if (hasMandalEntry) { mandalWiseData(selecteddept, firstDistRow.district_id); setselecteddist(districtName); } }} > {districtName} </td> )}

              <td style={{ textAlign: "right" }} className="sticky-col sticky-Mly">{first.ind_m_count || 0}</td> <td style={{ textAlign: "right" }} className="sticky-col sticky-Qly">{first.ind_q_count || 0}</td> <td style={{ textAlign: "right" }} className="sticky-col sticky-Hly">{first.ind_h_count || 0}</td> <td style={{ textAlign: "right" }} className="sticky-col sticky-Aly">{first.ind_a_count || 0}</td>
              <td style={{ textAlign: "right" }} className="sticky-col sticky-Bie">{first.ind_b_count || 0}</td> <td style={{ textAlign: "right" }} className="sticky-col sticky-5yrs">{first.ind_f_count || 0}</td> <td style={{ textAlign: "right" }} className="sticky-col sticky-Totalll">{first.ind_t_count || 0}</td>

              <td style={{ textAlign: "left" }} className="sticky-col sticky-KPIENTRYLEVEL">{first.entry_type || ""}</td> <td className="sticky-col sticky-KPITOTAL"   style={
                    first.target_counts ? { textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer", } : { textAlign: "right", verticalAlign: "middle" } } onClick={() => first.target_counts ? TargetCountData("District",first.ac_entrylevel,selecteddept,firstDistRow.district_id,"0") :"" }>{first.target_counts || 0}</td> 
                    <td style={{ textAlign: "right" }} className="sticky-col sticky-KPIINDICATORS">{first.tr_ind_count || 0}</td>

              

              
{/* {[4,5,6,7,8,9,10,11,12,1,2,3,13,14].map(order => { */}
{filteredPeriods.map(period => {
  const order = period.order;
  const monthHeadMap = {
    6: ["8","15"], 9: ["11","16","1"],       
    12: ["14","17"], 3: ["5","18","2","0"], };

  const getHeadIds = () => { let headIds = monthHeadMap[order] ? [...monthHeadMap[order]] : rows .filter(r => parseInt(r.month_order) === order) .map(r => r.head_id);

    // June main head first
    // if (order === 6) { const main = rows.find( r => parseInt(r.month_order) === 6 && r.head_id !== "15" ); 
      // if (main) headIds.unshift(main.head_id); } 
      return [...new Set(headIds)];
  };

  const getValues = (field) =>
    getHeadIds()?.map(hid => {const row = rows.find( r => parseInt(r.month_order) === order && r.head_id === hid);
      return { headId: hid, value: row?.[field] || 0 };
    });

  const renderTD = (field, isAcCount = false, clickable = false) => {
    const values = getValues(field);

    return (
      <td style={{ textAlign: "right", verticalAlign: "middle" }}>
        
        {values?.map((v, i) => v.value > 0 && clickable ? ( <span key={v.headId} role="button" tabIndex={0} style={{ color: "blue", cursor: "pointer" }}
      onClick={() => PendingAchCountData( "District", first.ac_entrylevel, selecteddept, firstDistRow.district_id, "0", isAcCount, v.headId ) }
      onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { PendingAchCountData( "District", first.ac_entrylevel, selecteddept, firstDistRow.district_id, "0", isAcCount, v.headId ); } }}
    >
      {v.value}{i < values.length - 1 ? " / " : ""}
    </span>
  ) : ( <span key={v.headId}> {v.value}{i < values.length - 1 ? " / " : ""} </span> )
)}

      </td>
    );
  };
  return (
    <React.Fragment key={order}>
      {renderTD("ac_counts", true, true)} {renderTD("ac_pending_count", false, true)}

      {renderTD("ac_ind_count")} {renderTD("ac_pending_ind_count")}
    </React.Fragment>
  );
})}

            </tr>
          );
        });
      });
    })()
  )}
</tbody>



</Table>



          </div>
        </div>            
        </>}


       {SubTableEnb && 
        <>

          <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex", borderRadius: "20px",alignItems: "center", border: "1px solid #ddd",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchSub} onChange={(e) => setSearchsub(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2">
            <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right",  marginLeft: "3px", color: "#ffffff" }} onClick={() => exportToExcel("my-table2", "indicatorWiseProgressReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
            <button type="button" size="sm" className="btn btn-warning btn-sm mx-2 warn-btn" style={{ float: "right", marginLeft: "3px" }} onClick={()=>{setSubTableData([]);setSubTableEnb(false);if(!["113","119","112"].includes(roleid)){setSubDistTableEnb(true);setmaintablenb(false);}else{setmaintablenb(true)}setSearch("");setSearchsub("");setSearchdistsub("");setsearchPendingAchText("");setsearchTargetsText("");setsearchTargetNamesText("");setsearchAchNamesText("")}}> <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button> </Col> </Row>

        
         <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1"> <span className="style"> Indicator Wise {subTableData[0]?.dept_name && ( <span style={{ color: "rgb(214 136 21)" }}> {subTableData[0]?.dept_name},</span> )} 
         <span style={{ color: "rgb(214 136 21)" }}> {roleid === "112" ? `${localStorage.getItem("assemblyname")} Constituency` : `${selecteddist} District`} </span> Progress</span> <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div> </div>
        <div id="table-scroll" className="table-scroll">
          <div className="table-wrap">
       

<Table bordered id="my-table2" className="table table-bordered custom-table table-responsive sticky-table">
    <thead>
          <tr className="text-center only-export">
            <th
              colSpan={76}
              style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}
            >
              
              Indicator Wise 
              {roleid === "112" ? `${localStorage.getItem("assemblyname")} Constituency` : `${selecteddist} District`} Progress Report
            </th>
          </tr>

          <tr className="text-center">
            <th
              style={headerStyle}
              className="sticky-col sticky-sno"
              rowSpan={3}
            >
              Sl.No.
            </th>

            <th
              className="sticky-col sticky-KPIHOD indicator-column"
              style={{ ...headerStyle, minWidth: "200px" }}
              rowSpan={3}
            >
              {ulbdeptlist.includes(selecteddept)?"ULB":"Mandal"} Name
            </th>

            

            <th style={headerStyle} colSpan={7} className="sticky-col sticky-KPIPERIODIC">
              Periodicity
            </th>

            <th style={headerStyle} rowSpan={3} className="sticky-col sticky-KPIENTRYLEVEL">
              Entry Level
            </th>
            <th style={headerStyle} rowSpan={3} className="sticky-col sticky-KPITOTAL">
              Total <br /> No.of Targets
            </th>
            <th style={headerStyle} rowSpan={3} className="sticky-col sticky-KPIINDICATORS">
              No.of Indicators <br /> Targets Provided
            </th>

            <th style={headerStyle} colSpan={14 * 4}>
              No.of Indicators Achievements Provided
            </th>
          </tr>

          <tr className="text-center">
            {[
              "M.ly",
              "Q.ly",
              "H.ly",
              "A.ly",
              "Bie.",
              "5 yrs",
              "Total",
            ].map((label) => (
              <th key={label} style={headerStyle} rowSpan={2} className={`sticky-col sticky-${label === "Total" ? "Totalll":label.replace(/[^a-zA-Z0-9_-]/g, "")}`}>
                {label}
              </th>
            ))}

            {/* {[
              { name: "April", order: 4 },
              { name: "May", order: 5 },
              { name: "June/Q1", order: 6 },
              { name: "July", order: 7 },
              { name: "Aug", order: 8 },
              { name: "Sept/Q2/HY1", order: 9 },
              { name: "Oct", order: 10 },
              { name: "Nov", order: 11 },
              { name: "Dec/Q3", order: 12 },
              { name: "Jan", order: 1 },
              { name: "Feb", order: 2 },
              { name: "Mar/Q4/HY2/Annual", order: 3 },
              { name: "Bi Ennial", order: 13 },
              { name: "5 year", order: 14 },
            ].map((period) => (
              <th key={period.name} style={headerStyle} colSpan={4}>
                {period.name}
              </th>
            ))} */}
             {filteredPeriods.map((period) => ( <th key={period.name} style={headerStyle} colSpan={4}> {period.name} </th> ))}
          </tr>

          <tr className="text-center">
            {/* {[
              "April",
              "May",
              "June/Q1",
              "July",
              "Aug",
              "Sept/Q2/HY1",
              "Oct",
              "Nov",
              "Dec/Q3",
              "Jan",
              "Feb",
              "Mar/Q4/HY2/Annual",
              "Bi Ennial",
              "5 year",
            ].map((period) => (
              <React.Fragment key={period}>
                <th style={headerStyle}>
                  Achievements <br /> Count
                </th>
                <th style={headerStyle}>
                  Pending <br /> Achievements <br /> Count
                </th>
                <th style={headerStyle}>
                  Achievements <br /> Indicators <br /> Count
                </th>
                <th style={headerStyle}>
                  Pending <br /> Indicators <br /> Count
                </th>
              </React.Fragment>
            ))} */}
               {filteredPeriods.map((period) => ( <React.Fragment key={period}> <th style={headerStyle}>Achievements <br/>Mandal<br />Count</th> <th style={headerStyle}>Pending <br />Achievements <br/>Mandal<br />Count</th> <th style={headerStyle}>Achievements <br />Indicators <br />Count</th> <th style={headerStyle}>Pending <br />Indicators <br />Count</th> </React.Fragment> ))}
          </tr>
        </thead>


 <tbody>
    {filteredDataSub?.length === 0 || filteredDataSub === undefined ? (
      <tr>
        <td className="text-center" colSpan={76}>
          <b style={{ color: "red" }}>Details Not Found</b>
        </td>
      </tr>
    ) : (
      (() => {
        let slno = 0;

        const groupedByDist = {};
        filteredDataSub.forEach((item) => {
          const key = item.mandal_id;
          if (!groupedByDist[key]) groupedByDist[key] = [];
          groupedByDist[key].push(item);
        });

        return Object.entries(groupedByDist).flatMap(([deptId, deptRows]) => {
          const firstDeptRow = deptRows[0];
          const districtName = firstDeptRow.mandal_name;
          const groupedByEntryType = {};
          deptRows.forEach((item) => {
            const key = item.entry_type || "Unknown";
            if (!groupedByEntryType[key]) groupedByEntryType[key] = [];
            groupedByEntryType[key].push(item);
          });

          const entryTypes = Object.keys(groupedByEntryType);
          const deptRowSpan = entryTypes.length;

          return entryTypes?.map((entryType, idx) => {
            slno += 1;
            const rows = groupedByEntryType[entryType];
            const first = rows[0];

            const getMonthData = (monthOrder) =>
              rows.find((r) => parseInt(r.month_order) === monthOrder) || {};

            return (
              <tr key={`${deptId}-${entryType}`}>
                
                <td className="sticky-col sticky-sno" style={{ textAlign: "center" }}>{slno}</td>

            
                {idx === 0 && (
                  <td
                    className="sticky-col sticky-KPIHOD indicator-column"
                    rowSpan={deptRowSpan}
                    
                  >
                    {districtName}
                  </td>
                )}

               
                <td style={{ textAlign: "right" }} className="sticky-col sticky-Mly">{first.ind_m_count || 0}</td>
                <td style={{ textAlign: "right" }} className="sticky-col sticky-Qly">{first.ind_q_count || 0}</td>
                <td style={{ textAlign: "right" }} className="sticky-col sticky-Hly">{first.ind_h_count || 0}</td>
                <td style={{ textAlign: "right" }} className="sticky-col sticky-Aly">{first.ind_a_count || 0}</td>
                <td style={{ textAlign: "right" }} className="sticky-col sticky-Bie">{first.ind_b_count || 0}</td>
                <td style={{ textAlign: "right" }} className="sticky-col sticky-5yrs">{first.ind_f_count || 0}</td>
                <td style={{ textAlign: "right" }} className="sticky-col sticky-Totalll">{first.ind_t_count || 0}</td>

              
                <td style={{ textAlign: "left" }} className="sticky-col sticky-KPIENTRYLEVEL">{first.entry_type || ""}</td>

              
                <td   style={
                    first.target_counts
                      ? {
                          textAlign: "right",
                          verticalAlign: "middle",
                          color: "blue",
                          cursor: "pointer",
                        }
                      : { textAlign: "right", verticalAlign: "middle" }
                  } className="sticky-col sticky-KPITOTAL" 
                  onClick={() => first.target_counts ? TargetCountData("Mandal",first.ac_entrylevel,selecteddept,firstDeptRow.district_id,firstDeptRow.mandal_id) :"" }>{first.target_counts || 0}</td>
                <td style={{ textAlign: "right" }} className="sticky-col sticky-KPIINDICATORS">{first.tr_ind_count || 0}</td>

               
             {/* {[4,5,6,7,8,9,10,11,12,1,2,3,13,14].map(order => { */}
{filteredPeriods.map(period => { const order = period.order;
  const monthHeadMap = { 6: ["8","15"], 9: ["11","16","1"], 12: ["14","17"], 3: ["5","18","2","0"], };

  const getHeadIds = () => {let headIds = monthHeadMap[order] ? [...monthHeadMap[order]] : rows .filter(r => parseInt(r.month_order) === order) ?.map(r => r.head_id);

    // if (order === 6) { const main = rows.find( r => parseInt(r.month_order) === 6 && r.head_id !== "15" ); if (main) headIds.unshift(main.head_id); }

    return [...new Set(headIds)]; };

  const getValues = (field) => getHeadIds()?.map(hid => { const row = rows.find( r => parseInt(r.month_order) === order && r.head_id === hid ); return { headId: hid, value: row?.[field] || 0 }; });

  const renderTD = (field, isAcCount = false, clickable = false) => { const values = getValues(field);

    return (
      <td style={{ textAlign: "right", verticalAlign: "middle" }}>
   {values?.map((v, i) => v.value > 0 && clickable ? (
    <span
      key={v.headId} role="button" tabIndex={0} style={{ color: "blue", cursor: "pointer" }}
      onClick={() =>
        PendingAchCountData( "Mandal", first.ac_entrylevel, selecteddept, firstDeptRow.district_id, firstDeptRow.mandal_id, isAcCount, v.headId )
      }
      onKeyDown={(e) => {if (e.key === "Enter" || e.key === " ") {
          PendingAchCountData( "Mandal", first.ac_entrylevel, selecteddept, firstDeptRow.district_id, firstDeptRow.mandal_id, isAcCount, v.headId );
        }
      }} > {v.value}{i < values.length - 1 ? " / " : ""} </span>
  ) : ( <span key={v.headId}> {v.value}{i < values.length - 1 ? " / " : ""} </span>
  )
)}

      </td>
    );
  };

  return ( <React.Fragment key={order}> {renderTD("ac_counts", true, true)} {renderTD("ac_pending_count", false, true)} {renderTD("ac_ind_count")} {renderTD("ac_pending_ind_count")} </React.Fragment> );
})}

              </tr> ); }); }); })() )} </tbody>

</Table>
          </div>
        </div>            
        </>
        }

<Modal  fade={false} dialogClassName="modal-xl" className="mandalmodel"aria-labelledby="contained-modal-title-vcenter" centered show={TargetCountEnb}>
                  <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Modal.Title className="text-center  fw-bold" style={{ margin: "0 auto", color: "white", fontFamily: "'Times New Roman', Times, serif" }}>
                      Targets Count 
                    </Modal.Title>
                    <button type="button" tabIndex="0" aria-label="Close" onClick={handleTargetcountClose} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleTargetcountClose(); } }} style={{ fontSize: "29px", cursor: "pointer", color: "black" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} > &#215; </button>
                  </Modal.Header>
                  <Modal.Body className="p-3">
                 
          <Row>
             <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="mb-3">
             <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex", borderRadius: "20px",alignItems: "center", border: "1px solid #ddd",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchTargetsText} onChange={(e) => setsearchTargetsText(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2">
            {/* <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right",  marginLeft: "3px", color: "#ffffff" }} onClick={() => exportToExcel("my-table3", "indicatorWiseProgressReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button> */}
           {/* {mandaltargetenb && <button type="button" size="sm" className="btn btn-warning btn-sm mx-2 warn-btn" style={{ float: "right", marginLeft: "3px" }} onClick={()=>{setTargetsData(TargetsdistData);setmandaltargetenb(false);}}
             > <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button>} */}

            </Col> 
            </Row>
       <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table bordered hover id="my-table3" className="custom-table table-responsive  table-striped table table-bordered" style={{ tableLayout: "fixed" }}>
                        <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>

          

          <tr className="text-center">
            <th style={headerStyle} className="sno-column"> Sl.No. </th>

            <th style={headerStyle} className="ind-column" > {((DrillType !== "Mandal") && !["111","117"].includes(roleid))  ? roleid==="112"? "Constituency":"District":ulbdeptlist?.includes(selecteddept)?"ULB":"Mandal"} Name </th>
          
            <th style={headerStyle} > Total Indicators <br /> Count </th>

            <th style={headerStyle}  > Total Targets <br /> Count </th>
            {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid)) &&<th style={headerStyle}  > Mandal <br />Targets Count </th>}

          </tr>
        </thead>
  <tbody>
                          {filteredTargetsData?.length === 0 || filteredTargetsData?.length === undefined ? (
                            <tr> <td className="text-center" colSpan={ (Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111"].includes(roleid)) ? "5":"4"}> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                          ) : (
                            (() => {
                              return filteredTargetsData?.map((detail, i) => {
                                return (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center"}} className="sticky-col sticky-sno">{i + 1}</td>
                                    <td style={(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid)&& detail.mandal_count>0) ?{textAlign: "left", verticalAlign: "middle", color: "blue", cursor: "pointer",wordBreak: "break-word" }:{textAlign: "left", verticalAlign: "middle",wordBreak: "break-word"}} 
                                   onClick={() => {
                                    if (Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111"].includes(roleid) && detail.mandal_count>0) {
                                    
                                    TargetmandalCountData(detail.district_id)
                                    }
                                  }}
                                  >
                                  {(DrillType !== "Mandal"&& !["111","117"].includes(roleid)) ? detail.district_name:detail.mandal_name}</td>
                                  <td style={{ textAlign: "right" }}>{detail.total_ind_count||"0"}</td>
                                                                    <td  style={(((Entry !== "mandalLevel" && DrillType !== "Mandal")||((Entry === "mandalLevel" && DrillType === "Mandal")|| ["111","117"].includes(roleid))) &&detail.targetscount>0) ? { textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer", } : { textAlign: "right", verticalAlign: "middle" } } 
                                                                    onClick={() => {
                                                                      
                                                                      if(((Entry !== "mandalLevel" && DrillType !== "Mandal")||((Entry === "mandalLevel" && DrillType === "Mandal")|| ["111","117"].includes(roleid)))){
                               
                                setTargetMandalEnb(false);
                                                                      setTargetsmandalData([]);
                                TargetNamesData(detail.district_id,detail.mandal_id ? detail.mandal_id:"0")}} }>{detail.targetscount||"0"}</td>
                                                                  {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid)) &&  <td  style={detail.mandal_count>0 ? { textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer", } : { textAlign: "right", verticalAlign: "middle" } } onClick={() => {if(detail.mandal_count>0){
                               
                                setTargetMandalEnb(false);
                                                                      setTargetsmandalData([]);
                                TargetNamesData(detail.district_id,detail.mandal_id ? detail.mandal_id:"0")}} }>{detail.mandal_count||"0"}</td>}
                                    </tr> 
                                    ); }); })() )}</tbody>
                                      <tfoot style={{ position: "sticky", bottom: "0px" }}>
    <tr style={{ backgroundColor: "#4e835c", fontWeight: "bold" }}>
      <td style={{...headerStyle, textAlign: "right"}} colSpan={2}>Total</td>

      <td style={{...headerStyle, textAlign: "right"}}>
        {filteredTargetsData?.reduce((sum, item) => sum + (parseFloat(item.total_ind_count) || 0), 0)}
      </td>
      <td style={{...headerStyle, textAlign: "right"}}>
        {filteredTargetsData?.reduce((sum, item) => sum + (parseFloat(item.targetscount) || 0), 0)}
      </td>
       {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid)) &&<td style={{...headerStyle, textAlign: "right"}}>
        {filteredTargetsData?.reduce((sum, item) => sum + (parseFloat(item.mandal_count) || 0), 0)}
      </td>}
    
    </tr>
  </tfoot>
</table></div>
 </Col>
{TargetMandalEnb &&
    <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="mb-3">
             <Row >
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex", borderRadius: "20px",alignItems: "center", border: "1px solid #ddd",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchmandalTargetsText} onChange={(e) => setsearchmandalTargetsText(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2">
           

            </Col> 
            </Row>
       <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table bordered hover id="my-table3" className="custom-table table-responsive  table-striped table table-bordered" style={{ tableLayout: "fixed" }}>
                        <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
          <tr className="text-center">
            <th style={headerStyle} className="sno-column"> Sl.No. </th>

            <th style={headerStyle} className="ind-column" > {ulbdeptlist?.includes(selecteddept)?"ULB":"Mandal"} Name </th>
          
            <th style={headerStyle} > Total Indicators <br /> Count </th>

            <th style={headerStyle}  > Total Targets <br /> Count </th>
            {/* {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid)) &&<th style={headerStyle}  > Mandal <br />Targets Count </th>} */}

          </tr>
        </thead>
  <tbody>
                          {filteredmandalTargetsData?.length === 0 || filteredmandalTargetsData?.length === undefined ? (
                            <tr> <td className="text-center" colSpan={"4"}> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                          ) : (
                            (() => {
                              return filteredmandalTargetsData?.map((detail, i) => {
                                return (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center"}} className="sticky-col sticky-sno">{i + 1}</td>
                                    <td style={{textAlign: "left", verticalAlign: "middle",wordBreak: "break-word"}} >
                                      {detail.mandal_name}</td>
                                    <td style={{ textAlign: "right" }}>{detail.total_ind_count_in_master||"0"}</td>
                                    <td   style={ detail.entered_targetscount >0 ?{textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer"}:{textAlign: "right", verticalAlign: "middle"} } 
                                    onClick={() => {    
                                      if(detail.entered_targetscount >0 )   {                         
                                    
                                    TargetNamesData(detail.district_id,detail.mandal_id ? detail.mandal_id:"0")} }}>{detail.entered_targetscount||"0"}</td>
                               

                                    </tr> 
                                    ); }); })() )}</tbody>
                                      <tfoot style={{ position: "sticky", bottom: "0px" }}>
    <tr style={{ backgroundColor: "#4e835c", fontWeight: "bold" }}>
      <td style={{...headerStyle, textAlign: "right"}} colSpan={2}>Total</td>

      <td style={{...headerStyle, textAlign: "right"}}>
        {filteredmandalTargetsData?.reduce((sum, item) => sum + (parseFloat(item.total_ind_count_in_master) || 0), 0)}
      </td>
      <td style={{...headerStyle, textAlign: "right"}}>
        {filteredmandalTargetsData?.reduce((sum, item) => sum + (parseFloat(item.entered_targetscount) || 0), 0)}
      </td>
      
    
    </tr>
  </tfoot>
</table></div>
 </Col>
}
 <Col xs={12} sm={12}  md={6} lg={6} xl={6} xxl={6}>
         <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex", borderRadius: "20px",alignItems: "center", border: "1px solid #ddd",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchTargetNamesText} onChange={(e) => setsearchTargetNamesText(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2">
            <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right",  marginLeft: "3px", color: "#ffffff" }} onClick={() => exportToExcel("targetind", "indicatorWiseProgressReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
            {/* <button type="button" size="sm" className="btn btn-warning btn-sm mx-2 warn-btn" style={{ float: "right", marginLeft: "3px" }} onClick={()=>{ modalsclose();setTargetCountEnb(true); }}> <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button> */}

           
              </Col> </Row>

        
     <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table bordered hover id="targetind" className="custom-table table-responsive  table-striped table table-bordered" style={{ tableLayout: "fixed" }}>
                        <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
          

          <tr className="text-center">
            <th style={headerStyle} className="sno-column" > Sl.No. </th>
            {(Entry === "mandalLevel" && DrillType !== "Mandal" && !["111","117"].includes(roleid) && !TargetMandalEnb) &&<th style={{ ...headerStyle, minWidth:"700px" }} className="ind-column"> {ulbdeptlist.includes(selecteddept)? "ULB": "Mandal"} Name </th>}

            <th style={headerStyle} className="ind-column"> Indicator Name </th>
            <th style={{ ...headerStyle, minWidth: "80px" }} className="unit-column"> Unit </th>
          
            <th style={headerStyle} > Target <br /> ({formik.values.year}) </th>
 <th style={headerStyle} > Target <br /> Status </th>
            
 </tr>
        </thead>
    <tbody>
                          {filteredTargetNamesData?.length === 0 || filteredTargetNamesData?.length === undefined ? (
                            <tr> <td className="text-center" colSpan={(Entry === "mandalLevel" && DrillType !== "Mandal" && !["111","117"].includes(roleid)&&!TargetMandalEnb)? "6":"5"}> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                          ) : (
                            (() => {
                              return filteredTargetNamesData?.map((detail, i) => {
                                return (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center" }} className="sno-column">{i + 1}</td>
            {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid)&& !TargetMandalEnb) &&<td style={{ textAlign: "left",minWidth:"700px",wordBreak: "break-word" }} className="ind-column"> {detail.mandal_name} </td>}

                                    <td style={{ textAlign: "left",minWidth:"700px",wordBreak: "break-word" }} className="ind-column">{detail.indicator_name}</td>
                                    <td style={{ textAlign: "left",minWidth:"80px",wordBreak: "break-word" }} className="unit-column">{detail.unit_name}</td>
                                    <td style={{ textAlign: "right" }}>{detail.targets_2025}</td>
                                    <td style={{ textAlign: "left",wordBreak: "break-word" }}>{detail.status_name}</td>
                                    

                                    </tr> 
                                    ); }); })() )}</tbody>
</table></div>
 </Col>
 </Row>
   
                    </Modal.Body> 
                      <Modal.Footer style={{ marginBottom: "20px" }}> <Button variant="danger" style={{ padding: "8px 20px", borderRadius: "30px" }}  onClick={handleTargetcountClose} className="mb-3"> Close </Button> </Modal.Footer>
                  </Modal>



<Modal  dialogClassName="modal-xl" className="mandalmodel" fade={false} size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={PendingAchEnb}>
                  <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Modal.Title className="text-center  fw-bold" style={{ margin: "0 auto", color: "white", fontFamily: "'Times New Roman', Times, serif" }}>
                      {EnteredAchEnb ? "Entered ":"Pending "}Achievements Count 
                    </Modal.Title>
                    <button type="button" tabIndex="0" aria-label="Close" onClick={handlePendingAchClose} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handlePendingAchClose(); } }} style={{ fontSize: "29px", cursor: "pointer", color: "black" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} > &#215; </button>
                  </Modal.Header>
                  <Modal.Body className="p-3">
                 
          <Row>
             <Col xs={12} sm={12} md={EnteredAchEnb?5:8} lg={EnteredAchEnb?5:8} xl={EnteredAchEnb?5:8} xxl={EnteredAchEnb?5:8} className="mb-3">
             <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex", borderRadius: "20px",alignItems: "center", border: "1px solid #ddd",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchPendingAchText} onChange={(e) => setsearchPendingAchText(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2">
            {/* <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right",  marginLeft: "3px", color: "#ffffff" }} onClick={() => exportToExcel("my-table3", "indicatorWiseProgressReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button> */}
           {/* {mandaltargetenb && <button type="button" size="sm" className="btn btn-warning btn-sm mx-2 warn-btn" style={{ float: "right", marginLeft: "3px" }} onClick={()=>{setPendingAChievementData(setinddistData);setmandaltargetenb(false);}}
             > <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button>} */}

            </Col> </Row>

        
       <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table bordered hover id="my-table4" className="custom-table table-responsive  table-striped table table-bordered" style={{ tableLayout: "fixed" }}>
                        <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>

          
          <tr className="text-center">
            <th style={{...headerStyle}} className="sno-column"  > Sl.No. </th>

            <th style={{ ...headerStyle}} className="ind-column" > {(DrillType !== "Mandal"&&!["111","117"].includes(roleid))  ? roleid==="112"? "Constituency":"District":ulbdeptlist?.includes(selecteddept)?"ULB":"Mandal"} Name </th>
<th style={headerStyle}> { !(Entry === "mandalLevel" && DrillType !== "Mandal" && !["111", "117"].includes(roleid) ) ? ( <> {EnteredAchEnb ? "Entered " : "Pending "} <br /> Targets <br /> Count </> ) : ( <> Total Indicators <br /> Count </> ) } </th>


            {(EnteredAchEnb ||(!EnteredAchEnb && Entry !== "mandalLevel"))&&<th style={headerStyle} > {EnteredAchEnb ? "Entered ":"Pending "}Achievements <br /> Count </th>}
             {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid)) &&<th style={headerStyle} > {EnteredAchEnb ? "Entered ":"Pending "} {ulbdeptlist?.includes(selecteddept)?"ULB":"Mandal"} <br /> Count </th>}
          </tr>
        </thead>
  <tbody>
                          {filteredAchievementsData?.length === 0 || filteredAchievementsData?.length === undefined ? (
                            <tr> <td className="text-center" 
                            colSpan={ 2 + 1 + ( (EnteredAchEnb || (!EnteredAchEnb && Entry !== "mandalLevel")) ? 1 : 0 ) + ( (Entry === "mandalLevel" && DrillType !== "Mandal" && !["111", "117"].includes(roleid)) ? 1 : 0 ) }
                            > <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                          ) : (
                            (() => {
                              return filteredAchievementsData?.map((detail, i) => {
                                return (
                                <tr key={i}>
        <td style={{ textAlign: "center" }} className="sno-column">
          {i + 1}
        </td>

        <td
          style={
            ((Entry === "mandalLevel" &&
              DrillType !== "Mandal" &&
              !["111"].includes(roleid) &&
              (EnteredAchEnb&& detail.entered_mandal_count > 0 )) ||
              (Entry === "mandalLevel" &&!EnteredAchEnb&& detail.pending_mandal_count > 0 ))
            
              ? { textAlign: "left", verticalAlign: "middle", color: "blue", cursor: "pointer", wordBreak: "break-word" }
              : { textAlign: "left", verticalAlign: "middle", wordBreak: "break-word" }
          }
          className="ind-column"
          onClick={() => {
            if (
              Entry === "mandalLevel" &&
              DrillType !== "Mandal" &&
               (EnteredAchEnb&& detail.entered_mandal_count > 0 )
            ) {
              
              AchievementmandalCountData(detail.district_id);
            }

            if(Entry === "mandalLevel" &&!EnteredAchEnb&& detail.pending_mandal_count > 0 ){
                  
         const params = {
    year: formik.values.year,
    userId: username,
    deptId: selecteddept,
    buttonType:"PendingMandal",
    districtId: roleid === "112" ? district :detail.district_id,
    ...(roleid === "112" ? {constId:assembleid}:{}),
    entryLevel: Entry,
    mandalId:"0",
    headId:Head_id
    
  };

  store.dispatch({ type: "SHOW_SPINNER" });

  KpiService.indicatorWiseProgressReport(params)
    .then((res) => {
        setPendingmandalenb(true);
   
setSelectedpendingDistrictName(detail.district_name);
      if (res.data && res.data.SCODE === "01") {
        setPendingmandalData(res.data?.SDESC);
       }
else{
        setPendingmandalData([]);
  // setPendingmandalenb(false);
}
    })
    .catch(() => { showAlertMessage("Failed to fetch data. Please try again.", "warning"); })
    .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
            }

            }
          }
        >
          {(DrillType !== "Mandal" && !["111","117"].includes(roleid))
            ? detail.district_name
            : detail.mandal_name}
        </td>

      
{
  !(Entry === "mandalLevel" &&
    DrillType !== "Mandal" &&
    !["111", "117"].includes(roleid)
  )
    ? (
      <td style={{ textAlign: "right" }}
        // style={
        //   (
        //     ((Entry !== "mandalLevel" && DrillType !== "Mandal") ||
        //       (Entry === "mandalLevel" && DrillType === "Mandal") ||
        //       ["111", "117"].includes(roleid)
        //     ) &&
        //     EnteredAchEnb &&
        //     detail.entered_indicatorcount > 0
        //   )
        //     ? {
        //         textAlign: "right",
        //         verticalAlign: "middle",
        //         color: "blue",
        //         cursor: "pointer",
        //       }
        //     : { textAlign: "right", verticalAlign: "middle" }
        // }
        // onClick={() => {
        //   if (
        //     ((Entry !== "mandalLevel" && DrillType !== "Mandal") ||
        //       (Entry === "mandalLevel" && DrillType === "Mandal") ||
        //       ["111", "117"].includes(roleid)
        //     ) &&
        //     EnteredAchEnb &&
        //     detail.entered_indicatorcount > 0
        //   ) {
        //     IndicatorNamesData(
        //       detail.district_id,
        //       detail.mandal_id ? detail.mandal_id : "0"
        //     );
        //   }
        // }}
      >
        {EnteredAchEnb
          ? detail.entered_targetcount || "0"
          : detail.pending_targets_indicators || "0"}
      </td>
    )
    : (
      <td style={{ textAlign: "right" }}>
        {detail.total_ind_count_in_master || "0"}
      </td>
    )
}

 {(EnteredAchEnb ||(!EnteredAchEnb && Entry !== "mandalLevel"))&&<td
          style={
            (((Entry !== "mandalLevel" && DrillType !== "Mandal")
            ||((Entry === "mandalLevel" && DrillType === "Mandal")|| ["111","117"].includes(roleid)))
             && EnteredAchEnb &&detail.entered_indicatorcount > 0 )
              ? { textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer" }
              : { textAlign: "right", verticalAlign: "middle" }
          }
          onClick={() => {
           
            if (
              (((Entry !== "mandalLevel" && DrillType !== "Mandal")||((Entry === "mandalLevel" && DrillType === "Mandal")|| ["111","117"].includes(roleid)))
             && EnteredAchEnb &&detail.entered_indicatorcount > 0 )
            ) {
             
             
              IndicatorNamesData(detail.district_id, detail.mandal_id ? detail.mandal_id : "0");
            }
          }}
        >
          {EnteredAchEnb
            ? detail.entered_indicatorcount || "0"
            : detail.pending_indicators || "0"}
        </td>}
 

        {(Entry === "mandalLevel" &&
          DrillType !== "Mandal" &&
          !["111","117"].includes(roleid)) && (
        
        
            <td
            style={
              (EnteredAchEnb && detail.entered_mandal_count > 0 )
                ? { textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer" }
                : { textAlign: "right", verticalAlign: "middle" }
            }
            onClick={() => {
            
              if (
               (EnteredAchEnb && detail.entered_mandal_count > 0 )
              ) {
                
                  setAchMandalEnb(false);
            setAchmandalData([]);
                IndicatorNamesData(detail.district_id, detail.mandal_id ? detail.mandal_id : "0");
              }
            }}
          >
            {EnteredAchEnb
              ? detail.entered_mandal_count || "0"
              : detail.pending_mandal_count || "0"}
          </td>
        )}
      </tr>
                                    ); }); })() )}</tbody>

                                
                                        <tfoot style={{ position: "sticky", bottom: "0px" }}>
    <tr style={{ backgroundColor: "#4e835c", fontWeight: "bold" }}>
      <td style={{...headerStyle, textAlign: "right"}} colSpan={2}>Total</td>
{
  !(Entry === "mandalLevel" &&
    DrillType !== "Mandal" &&
    !["111", "117"].includes(roleid)
  )
    ? (
      <td style={{...headerStyle, textAlign: "right"}}>
        {filteredAchievementsData?.reduce((sum, item) => sum + (parseFloat(EnteredAchEnb ? item.entered_targetcount : item.pending_targets_indicators ) || 0), 0)}
      </td>):(
      <td style={{...headerStyle, textAlign: "right"}}>
        {filteredAchievementsData?.reduce((sum, item) => sum + (parseFloat(item.total_ind_count_in_master) || 0), 0)}
      </td>
      )}
    {(EnteredAchEnb ||(!EnteredAchEnb && Entry !== "mandalLevel"))&&  <td style={{...headerStyle, textAlign: "right"}}>
        {filteredAchievementsData?.reduce((sum, item) => sum + (parseFloat(EnteredAchEnb ? item.entered_indicatorcount: item.pending_indicators) || 0), 0)}
      </td>}
      {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid)) &&<td style={{...headerStyle, textAlign: "right"}}>
        {filteredAchievementsData?.reduce((sum, item) => sum + (parseFloat(EnteredAchEnb ? item.entered_mandal_count: item.pending_mandal_count) || 0), 0)}
      </td>}
    
    </tr>
  </tfoot>
</table></div>
</Col>
{Pendingmandalenb &&<>

<Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mt-5">
             
       <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table bordered hover id="my-table4" className="custom-table table-responsive  table-striped table table-bordered" style={{ tableLayout: "fixed" }}>
                        <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>

          
<tr className="text-center">
            <th style={{...headerStyle}} className="sno-column" colSpan={2} >{roleid==="112"? "Constituency": "District"}: {selectedpendingDistrictName} </th></tr>
          <tr className="text-center">
            <th style={{...headerStyle}} className="sno-column"  > Sl.No. </th>

            <th style={{ ...headerStyle}} className="ind-column" > {ulbdeptlist?.includes(selecteddept)?"ULB":"Mandal"} Name </th>
          </tr>
        </thead>
  <tbody>
                          {PendingmandalData?.length === 0 || PendingmandalData?.length === undefined ? (
                            <tr> <td className="text-center" colSpan={2}> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                          ) : (
                            (() => {
                              return PendingmandalData?.map((detail, i) => {
                                return (
                                <tr key={i}>
        <td style={{ textAlign: "center"}} className="sno-column">
          {i + 1}
        </td>

        <td
          style={
            { textAlign: "left", verticalAlign: "middle", wordBreak: "break-word" }
          }
          className="ind-column"
         
        >
          {detail.mandal_name}
        </td>
       
      </tr>
                                    ); }); })() )}</tbody>

                                
                         
</table></div>
 </Col></>
}
{AchMandalEnb &&
    <Col xs={12} sm={12} md={6} lg={6} xl={6} xxl={6} className="mb-3">
             <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex", borderRadius: "20px",alignItems: "center", border: "1px solid #ddd",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchmandalAchText} onChange={(e) => setsearchmandalAchText(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2">
           

            </Col> 
            </Row>
       <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table bordered hover id="my-table4" className="custom-table table-responsive  table-striped table table-bordered" style={{ tableLayout: "fixed" }}>
                        <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>

          

          <tr className="text-center">
            <th style={{...headerStyle}} className="sno-column"  > Sl.No. </th>

            <th style={{ ...headerStyle}} className="ind-column" > {ulbdeptlist?.includes(selecteddept)?"ULB":"Mandal"} Name </th>
          
            <th style={headerStyle} > Total <br />Indicators <br /> Count </th>
            <th style={headerStyle} > {EnteredAchEnb ? "Entered ":"Pending "}Achievements <br /> Count </th>
             {/* {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid)) &&<th style={headerStyle} > Mandal <br />Achievements Count </th>} */}
          </tr>
        </thead>
  <tbody>
                          {filteredmandalAchsData?.length === 0 || filteredmandalAchsData?.length === undefined ? (
                            <tr> <td className="text-center" colSpan={(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid))?"5":"4"}> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                          ) : (
                            (() => {
                              return filteredmandalAchsData?.map((detail, i) => {
                                return (
                                <tr key={i}>
        <td style={{ textAlign: "center" }} className="sno-column">
          {i + 1}
        </td>

        <td
          style={
            { textAlign: "left", verticalAlign: "middle", wordBreak: "break-word" }
          }
          className="ind-column"
         
        >
          {detail.mandal_name}
        </td>

        <td style={{ textAlign: "right" }}>
          {detail.total_ind_count_in_master || "0"}
        </td>

        <td
          style={
            (EnteredAchEnb
            ? detail.entered_indicatorcount >0
            : detail.pending_indicators >0) ?{textAlign: "right", verticalAlign: "middle", color: "blue", cursor: "pointer"}:{textAlign: "right", verticalAlign: "middle"} 
            
          }
          onClick={() => {
            if(EnteredAchEnb
            ? detail.entered_indicatorcount >0
            : detail.pending_indicators >0){
                 
              
                IndicatorNamesData(detail.district_id, detail.mandal_id ? detail.mandal_id : "0");
            }
            }
          }
        >
          {EnteredAchEnb
            ? detail.entered_indicatorcount || "0"
            : detail.pending_indicators || "0"}
        </td>

       
      </tr>
                                    ); }); })() )}</tbody>

                                
                                        <tfoot style={{ position: "sticky", bottom: "0px" }}>
    <tr style={{ backgroundColor: "#4e835c", fontWeight: "bold" }}>
      <td style={{...headerStyle, textAlign: "right"}} colSpan={2}>Total</td>

      <td style={{...headerStyle, textAlign: "right"}}>
        {filteredmandalAchsData?.reduce((sum, item) => sum + (parseFloat(item.total_ind_count_in_master) || 0), 0)}
      </td>
      <td style={{...headerStyle, textAlign: "right"}}>
        {filteredmandalAchsData?.reduce((sum, item) => sum + (parseFloat(EnteredAchEnb ? item.entered_indicatorcount: item.pending_indicators) || 0), 0)}
      </td>
     
    
    </tr>
  </tfoot>
</table></div>
 </Col>
}
{EnteredAchEnb &&
<Col xs={12} sm={12} md={AchMandalEnb? 10:7} lg={AchMandalEnb? 10:7} xl={AchMandalEnb? 10:7} xxl={AchMandalEnb? 10:7}>
      <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex", borderRadius: "20px",alignItems: "center", border: "1px solid #ddd",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchAchNamesText} onChange={(e) => setsearchAchNamesText(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2">
            <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right",  marginLeft: "3px", color: "#ffffff" }} onClick={() => exportToExcel("AcmntInd", "indicatorWiseProgressReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
            {/* <button type="button" size="sm" className="btn btn-warning btn-sm mx-2 warn-btn" style={{ float: "right", marginLeft: "3px" }} onClick={()=>{ modalsclose();setPendingAchEnb(true); }}> <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button> */}

           
              </Col> </Row>

        
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table bordered hover id="AcmntInd" className="custom-table table-responsive  table-striped table table-bordered" style={{ tableLayout: "fixed" }}>
                        <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
          

          <tr className="text-center">
            <th style={{...headerStyle}} className="sno-column" > Sl.No. </th>
  {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid) && !AchMandalEnb) &&<th style={{ ...headerStyle}} className="ind-column"> {ulbdeptlist.includes(selecteddept)? "ULB": "Mandal"} Name </th>}
            <th style={{ ...headerStyle}} className="ind-column"> Indicator Name </th>
            <th style={headerStyle} className="unit-column"> Unit </th>
            <th style={{...headerStyle,width:"90px",minWidth:"100px",maxWidth:"150px"}} className="unit-column"> Periodicity </th>
            <th style={headerStyle} className="unit-column"> Category </th>
          
            <th style={{...headerStyle,width:"90px",minWidth:"100px",maxWidth:"150px"}} >Numerator </th>
            <th style={{...headerStyle,width:"90px",minWidth:"100px",maxWidth:"150px"}} >Denominator </th>
            {/* <th style={{...headerStyle,width:"110px",minWidth:"100px",maxWidth:"150px"}} >Numerator/<br/> Denominator </th> */}
            <th style={headerStyle} >Achieved Value </th>
 <th style={headerStyle} >Status </th>
            
 </tr>
        </thead>
  
  
<tbody>
  {(!filteredAchievementnamessData || filteredAchievementnamessData.length === 0) ? (
    <tr>
      <td className="text-center" colSpan={(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111","117"].includes(roleid)&&!AchMandalEnb)?"10":"9"}>
        <b style={{ color: "red" }}>Details Not Found</b>
      </td>
    </tr>
  ) : (
    filteredAchievementnamessData?.map((detail, i) => (
      <tr key={i}>
        <td className="sno-column" style={{ textAlign: "center" }}>
          {i + 1}
        </td>

        {(Entry === "mandalLevel" &&
          DrillType !== "Mandal" &&
          !["111","117"].includes(roleid)&&!AchMandalEnb) && (
          <td className="ind-column" style={{ textAlign: "left", wordBreak: "break-word" }}>
            {detail.mandal_name}
          </td>
        )}

        <td className="ind-column" style={{ textAlign: "left", wordBreak: "break-word" }}>
          {detail.indicator_name}
        </td>

        <td className="unit-column" style={{ textAlign: "left", wordBreak: "break-word" }}>
          {detail.unit_name}
        </td>
        <td className="unit-column" style={{ textAlign: "left", wordBreak: "break-word" }}>
          {detail.periodic_name}
        </td>
        <td className="unit-column" style={{ textAlign: "left", wordBreak: "break-word" }}>
          {detail.head_name=== null ? "-" : detail.head_name}
        </td>
        <td style={{ textAlign: "right" }}>
          {detail.numerator === null ? "-" : detail.numerator}
        </td>

        <td style={{ textAlign: "right" }}>
          {detail.denominator === null ? "-" : detail.denominator}
        </td>

        <td style={{ textAlign: "right" }}>
          {detail.indicator_value === null ? "-" : detail.indicator_value}
        </td>

        <td style={{ textAlign: "left",wordBreak: "break-word" }}>
          {detail.status_name}
        </td>
      </tr>
    ))
  )}
</tbody>
{/* <tbody>
  {(!filteredAchievementnamessData || filteredAchievementnamessData.length === 0) ? (
    <tr>
      <td className="text-center" colSpan={(Entry === "mandalLevel" && DrillType !== "Mandal" && !["111","117"].includes(roleid)) ? "11" : "10"}>
        <b style={{ color: "red" }}>Details Not Found</b>
      </td>
    </tr>
  ) : (

    Object.entries(
      filteredAchievementnamessData.reduce((acc, row) => {
        if (!acc[row.mandal_id]) acc[row.mandal_id] = [];
        acc[row.mandal_id].push(row);
        return acc;
      }, {})
    ).map(([mandalId, rows], mandalIndex) => {

      const mandalName = rows[0].mandal_name; 

      return rows.map((detail, i) => (
        <tr key={`${mandalId}-${i}`}>

          {i === 0 && (
            <td
              rowSpan={rows.length}
              className="sno-column"
              style={{ textAlign: "center", verticalAlign: "top" }}
            >
              {mandalIndex + 1}
            </td>
          )}

          {(Entry === "mandalLevel" &&
            DrillType !== "Mandal" &&
            !["111", "117"].includes(roleid)) &&
            i === 0 && (
              <td
                rowSpan={rows.length}
                className="ind-column"
                style={{ textAlign: "left", verticalAlign: "top",  wordBreak: "break-word" }}
              >
                {mandalName}
              </td>
            )
          }

          <td className="ind-column" style={{ textAlign: "left", wordBreak: "break-word" }}>
            {detail.indicator_name}
          </td>

          <td className="unit-column" style={{ textAlign: "left", wordBreak: "break-word" }}>
            {detail.unit_name}
          </td>

          <td className="unit-column" style={{ textAlign: "left", wordBreak: "break-word" }}>
            {detail.periodic_name}
          </td>

          <td className="unit-column" style={{ textAlign: "left", wordBreak: "break-word" }}>
            {detail.head_name ?? "-"}
          </td>

          <td style={{ textAlign: "right" }}>
            {detail.numerator ?? "-"}
          </td>

          <td style={{ textAlign: "right" }}>
            {detail.denominator ?? "-"}
          </td>

          

          <td style={{ textAlign: "right" }}>
            {detail.indicator_value ?? "-"}
          </td>

          <td style={{ textAlign: "left", wordBreak: "break-word" }}>
            {detail.status_name}
          </td>

        </tr>
      ));
    })
  )}
</tbody> */}


</table></div>
</Col>
}
 </Row>
    
                    </Modal.Body> 
                     <Modal.Footer style={{ marginBottom: "20px" }}> <Button variant="danger" style={{ padding: "8px 20px", borderRadius: "30px" }}  onClick={handlePendingAchClose} className="mb-3"> Close </Button> </Modal.Footer>
                     </Modal>

{/* <Modal className="newmodal" fade={false} size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={AchievementNamesEnb}>
                  <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Modal.Title className="text-center  fw-bold" style={{ margin: "0 auto", color: "black", fontFamily: "'Times New Roman', Times, serif" }}>
                     {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111"].includes(roleid))?`${capitalizedformat(selectedpopupdist)} District`:`${capitalizedformat(selectedpopupmandal)} ${ulbdeptlist.includes(selecteddept) ? "ULB":"Mandal"}`} {EnteredAchEnb ? "Entered" :"Pending"} Achievements Data 
                    </Modal.Title>
                    <button type="button" tabIndex="0" aria-label="Close" onClick={handleAchievementnamesClose} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleAchievementnamesClose(); } }} style={{ fontSize: "29px", cursor: "pointer", color: "black" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} > &#215; </button>
                  </Modal.Header>
                  <Modal.Body className="p-3">
                 
          <Row>
             
            
          <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex", borderRadius: "20px",alignItems: "center", border: "1px solid #ddd",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchAchNamesText} onChange={(e) => setsearchAchNamesText(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2">
            <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right",  marginLeft: "3px", color: "#ffffff" }} onClick={() => exportToExcel("my-table3", "indicatorWiseProgressReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
            <button type="button" size="sm" className="btn btn-warning btn-sm mx-2 warn-btn" style={{ float: "right", marginLeft: "3px" }} onClick={()=>{ modalsclose();setPendingAchEnb(true); }}> <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button>

           
              </Col> </Row>

        
      <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table bordered hover id="my-table3" className="custom-table table-responsive  table-striped table table-bordered" style={{ tableLayout: "fixed" }}>
                        <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
          

          <tr className="text-center">
            <th style={{...headerStyle}} className="sticky-col sticky-sno" > Sl.No. </th>
  {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111"].includes(roleid)) &&<th style={{ ...headerStyle, minWidth:"700px" }} > {ulbdeptlist.includes(selecteddept)? "ULB": "Mandal"} Name </th>}
            <th style={{ ...headerStyle, minWidth:"300px" }} className="sticky-col sticky-KPIHOD indicator-column"> Indicator Name </th>
            <th style={headerStyle} className="unit-column"> Unit </th>
          
            <th style={headerStyle} >Numerator </th>
            <th style={headerStyle} >Denominator </th>
            <th style={headerStyle} >Achieved Value </th>
 <th style={headerStyle} >Status </th>
            
 </tr>
        </thead>
    <tbody>
                          {filteredAchievementnamessData?.length === 0 || filteredAchievementnamessData?.length === undefined ? (
                            <tr> <td className="text-center" colSpan="7"> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                          ) : (
                            (() => {
                              return filteredAchievementnamessData?.map((detail, i) => {
                                return (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center" }} className="sticky-col sticky-sno">{i + 1}</td>
                                    <td style={{ textAlign: "left" }} className="sticky-col sticky-KPIHOD indicator-column">{detail.indicator_name}</td>
                                    <td style={{ textAlign: "left" }} className="unit-column">{detail.unit_name}</td>
                                    <td style={{ textAlign: "right" }}>{detail.numerator}</td>
                                    <td style={{ textAlign: "right" }}>{detail.denominator}</td>
                                    <td style={{ textAlign: "right" }}>{detail.indicator_value}</td>
                                    <td style={{ textAlign: "right" }}>{detail.status_name}</td>
                                    

                                    </tr> 
                                    ); }); })() )}</tbody> 
                                    <tbody>
  {(() => {
    const data = filteredAchievementnamessData || [];

    const finalList = EnteredAchEnb
      ? data.filter(item => item.status_id === 4)
      : data.filter(item => item.status_id !== 4);

    if (finalList.length === 0) {
      return (
        <tr>
          <td className="text-center" colSpan={(Entry === "mandalLevel" && DrillType !== "Mandal" && !["111"].includes(roleid))? "8":"7"}>
            <b style={{ color: "red" }}>Details Not Found</b>
          </td>
        </tr>
      );
    }

    return finalList.map((detail, i) => (
      <tr key={i}>
        <td style={{ textAlign: "center" }} className="sticky-col sticky-sno">
          {i + 1}
        </td>
 {(Entry === "mandalLevel" && DrillType !== "Mandal"&& !["111"].includes(roleid)) &&<td style={{ textAlign: "left",minWidth:"700px",wordBreak: "break-word" }} > {detail.mandal_name} </td>}
        <td
          style={{ textAlign: "left",minWidth:"300px",wordBreak: "break-word", }}
          className="sticky-col sticky-KPIHOD indicator-column"
        >
          {detail.indicator_name}
        </td>

        <td style={{ textAlign: "left",wordBreak: "break-word" }} className="unit-column">
          {detail.unit_name}
        </td>

        <td style={{ textAlign: "right" }}>{detail.numerator=== null ? "-":detail.numerator}</td>
        <td style={{ textAlign: "right" }}>{detail.denominator=== null ? "-":detail.denominator}</td>
        <td style={{ textAlign: "right" }}>{detail.indicator_value=== null ? "-":detail.indicator_value}</td>
        <td style={{ textAlign: "left" }}>{detail.status_name}</td>
      </tr>
    ));
  })()}
</tbody>

</table></div>
 
 </Row>

               
                    
                    </Modal.Body> <Modal.Footer> <button variant="primary" onClick={handleAchievementnamesClose} className="cancel"> Close </button> </Modal.Footer> </Modal>

 */}

{/* 
<Modal className="newmodal" fade={false} size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={PendingAchEnb}>
                  <Modal.Header style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Modal.Title className="text-center  fw-bold" style={{ margin: "0 auto", color: "black", fontFamily: "'Times New Roman', Times, serif" }}>
                     Indicators 
                    </Modal.Title>
                    <button type="button" tabIndex="0" aria-label="Close" onClick={handleTargetNamesClose} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleTargetNamesClose(); } }} style={{ fontSize: "29px", cursor: "pointer", color: "black" }} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} > &#215; </button>
                  </Modal.Header>
                  <Modal.Body className="p-3">
                 
          <Row>
             
            
          <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex", borderRadius: "20px",alignItems: "center", border: "1px solid #ddd",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchTargetNamesText} onChange={(e) => setsearchTargetNamesText(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2">
            <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right",  marginLeft: "3px", color: "#ffffff" }} onClick={() => exportToExcel("my-table3", "indicatorWiseProgressReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
            <button type="button" size="sm" className="btn btn-warning btn-sm mx-2 warn-btn" style={{ float: "right", marginLeft: "3px" }} onClick={()=>{
              if(DrillType === "HOD"){setmaintablenb(true)}if(DrillType === "District"){setSubDistTableEnb(true)}
            if(DrillType === "Mandal"){setSubTableEnb(true)};setTargetCountEnb(false);setPendingAchEnb(false);setSearch("");setSearchsub("");setSearchdistsub("");setsearchPendingAchText("");setsearchTargetsText("");setsearchTargetNamesText("");setsearchAchNamesText("")}}> <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button>

           
              </Col> </Row>

        
        <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
    
<Table bordered id="my-table3" className="table table-bordered custom-table table-responsive sticky-table"> 
 <thead>
          

          <tr className="text-center">
            <th style={headerStyle} className="sticky-col sticky-sno" rowSpan={3} > Sl.No. </th>

            <th style={{ ...headerStyle, minWidth: "200px" }} className="sticky-col sticky-KPIHOD indicator-column"> Indicator Name </th>
            <th style={headerStyle} > Unit </th>
          
            <th style={headerStyle} > Target <br /> ({formik.values.year}) </th>

            
 </tr>
        </thead>
    <tbody>
                          {filteredTargetNamesData?.length === 0 || filteredTargetNamesData?.length === undefined ? (
                            <tr> <td className="text-center" colSpan="8"> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
                          ) : (
                            (() => {
                              return filteredTargetNamesData?.map((detail, i) => {
                                return (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center" }}>{i + 1}</td>
                                    <td style={{ textAlign: "left" }} className="sticky-col sticky-KPIHOD indicator-column">{detail.indicator_name}</td>
                                    <td style={{ textAlign: "left" }}>{detail.unit_name}</td>
                                    <td style={{ textAlign: "right" }}>{detail.targets_2025}</td>
                                    

                                    </tr> 
                                    ); }); })() )}</tbody>
</Table></div></div>
 
 </Row>

               
                    
                    </Modal.Body> <Modal.Footer> <button variant="primary" onClick={handleTargetNamesClose} className="cancel"> Close </button> </Modal.Footer> </Modal>
 */}




  

  
     {/* {TargetNamesEnb &&<>
          <Row>
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3"> <div style={{ display: "flex", borderRadius: "20px",alignItems: "center", border: "1px solid #ddd",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", transition: "all 0.3s ease-in-out", backgroundColor: "#fff", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container"> <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} /> <input type="text" placeholder="Search" value={searchTargetNamesText} onChange={(e) => setsearchTargetNamesText(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} /> </div> </Col>
            <Col className="mb-2">
            <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right",  marginLeft: "3px", color: "#ffffff" }} onClick={() => exportToExcel("my-table3", "indicatorWiseProgressReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
            <button type="button" size="sm" className="btn btn-warning btn-sm mx-2 warn-btn" style={{ float: "right", marginLeft: "3px" }} onClick={()=>{
             setTargetCountEnb(true);setPendingAchEnb(false);setSearch("");setSearchsub("");setSearchdistsub("");setsearchPendingAchText("");setsearchTargetsText("");setsearchTargetNamesText("");setsearchAchNamesText("")}}> <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> Back </button> </Col> </Row>

        
        <div id="table-scroll" className="table-scroll"> <div className="table-wrap">
    
<Table bordered id="my-table3" className="table table-bordered custom-table table-responsive sticky-table"> 
 <thead>
          <tr className="text-center only-export">
            <th
              colSpan={76}
              style={{ backgroundColor: "#d4e3d8", textAlign: "center" }}
            >
              Indicator Wise Progress Report
            </th>
          </tr>

          <tr className="text-center">
            <th
              style={headerStyle}
              className="sticky-col sticky-sno"
              rowSpan={3}
            >
              Sl.No.
            </th>

            <th
              className="sticky-col sticky-KPIHOD indicator-column"
              style={{ ...headerStyle, minWidth: "200px" }}
              rowSpan={3}
            >
              {ulbdeptlist.includes(selecteddept)?"ULB":"Mandal"} Name
            </th>

            

            <th style={headerStyle} colSpan={7} className="sticky-col sticky-KPIPERIODIC">
              Periodicity
            </th>

            <th style={headerStyle} rowSpan={3} className="sticky-col sticky-KPIENTRYLEVEL">
              Entry Level
            </th>
            <th style={headerStyle} rowSpan={3} className="sticky-col sticky-KPITOTAL">
              Total <br /> No.of Targets
            </th>
            <th style={headerStyle} rowSpan={3} className="sticky-col sticky-KPIINDICATORS">
              No.of Indicators <br /> Targets Provided
            </th>

            <th style={headerStyle} colSpan={14 * 4}>
              No.of Indicators Achievements Provided
            </th>
          </tr>

          <tr className="text-center">
            {[
              "M.ly",
              "Q.ly",
              "H.ly",
              "A.ly",
              "Bie.",
              "5 yrs",
              "Total",
            ].map((label) => (
              <th key={label} style={headerStyle} rowSpan={2} className={`sticky-col sticky-${label === "Total" ? "Totalll":label.replace(/[^a-zA-Z0-9_-]/g, "")}`}>
                {label}
              </th>
            ))}

            {[
              { name: "April", order: 4 },
              { name: "May", order: 5 },
              { name: "June/Q1", order: 6 },
              { name: "July", order: 7 },
              { name: "Aug", order: 8 },
              { name: "Sept/Q2/H1", order: 9 },
              { name: "Oct", order: 10 },
              { name: "Nov", order: 11 },
              { name: "Dec/Q3", order: 12 },
              { name: "Jan", order: 1 },
              { name: "Feb", order: 2 },
              { name: "Mar/Q4/HY2/Annual", order: 3 },
              { name: "Bi Ennial", order: 13 },
              { name: "5 year", order: 14 },
            ].map((period) => (
              <th key={period.name} style={headerStyle} colSpan={4}>
                {period.name}
              </th>
            ))}
          </tr>

          <tr className="text-center">
            {[
              "April",
              "May",
              "June/Q1",
              "July",
              "Aug",
              "Sept/Q2/H1",
              "Oct",
              "Nov",
              "Dec/Q3",
              "Jan",
              "Feb",
              "Mar/Q4/H2/Annual",
              "Bi Ennial",
              "5 year",
            ].map((period) => (
              <React.Fragment key={period}>
                <th style={headerStyle}>
                  Achievements <br /> Count
                </th>
                <th style={headerStyle}>
                  Pending <br /> Achievements <br /> Count
                </th>
                <th style={headerStyle}>
                  Achievements <br /> Indicators <br /> Count
                </th>
                <th style={headerStyle}>
                  Pending <br /> Indicators <br /> Count
                </th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
  <tbody></tbody>
</Table></div></div>


     </> } */}
            </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
